import { formatPoaQuestionLabel } from '../../utils/poaDisplay'
import React, { useEffect, useState, useRef } from 'react'
import {
  CFormTextarea,
  CCard,
  CButton,
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter,
  CNav,
  CNavItem,
  CNavLink,
  CTabContent,
  CTabPane,
  CCardBody,
  CFormInput,
  CFormLabel,
  CForm,
  CRow,
  CCol,
  CTable,
  CTableBody,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
  CTableDataCell,
  CBadge,
  CCardSubtitle,
} from '@coreui/react'
import Select from 'react-select'
import MedicationTable from './MedicationTable'
import { Form, Formio } from '@formio/react'
import GetQuestionBank from '../../services/general/saveQuestionBank.api'
import GetPatientDiagnosisDetails from '../../services/general/getPatientDiagnosisDetails.api'
import GetDiagnosisData from '../../services/general/getDiagnosisData.api'
import HighlightedText from './../../components/shared/HighlightedText'
import LabDisplayComponent from './LabDisplayComponent'
import ModifyPatientHistory from '../../services/general/modifyPatientHistory.api'
import getPatientPersonalHistory from '../../services/general/getPatientHistory.api'
import CustomAccordionComponent from '../../components/shared/CustomAccordionComponent'
import MedicineCRUD from '../../services/general/Medication.api'
import FinalNoteDisplayImaging from './FinalNoteDisplayImaging'
import AsseseementFinalNote from './Asseseement'
import PatientQuestionPoa from './PatientQuestionPoa'
import NoteMedicationsDisplay from './NoteMedicationsDisplay'
import MorseBimsScore from '../../components/shared/MorseBimsScore'
import HPIQuestions from './HPIQuestions'
import { Resolution, usePDF } from 'react-to-pdf'

import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'
import SaveExtra from '../../../src/services/general/saveExtraData.api'
import fetchPatientData from '../../../src/services/general/patientGeneralAPI.api'
import Carder from '../../../src/components/shared/Carder'
import ShowHpiPatientInNoteView from './ShowHpiPatientInNoteView'
import MorseScore from '../../components/shared/MorseScore'
import FacilityCRUD from '../../../src/services/general/getFacilityData.api'
import Graytextarea from '../../../src/components/Graytextarea'

import Editor, { BtnBold, BtnBulletList, BtnItalic, BtnLink, BtnNumberedList, BtnRedo, BtnStrikeThrough, BtnStyles, BtnUnderline, BtnUndo, Separator, Toolbar } from 'react-simple-wysiwyg'
import PESelectedData from './PESelectedData'
import GESelectedData from '../../utils/GESelectedData.json'
import axios from 'axios'
import PatientPhysicalExaminationData from '../../../src/services/general/physicalExaminationData.api'
import PatientOrdersCRUD from '../../../src/services/general/patientOrders.api'
import Loader from '../../../src/components/shared/Loader'
import { cifKg } from '@coreui/icons'
import PatientAppointmentDetails from '../../../src/services/general/appointmentData.api'
import { getAllAppointments, getAllAppointmentsDetails } from '../../../src/components/shared/appointmentFilterData'
import Highlighter from 'react-highlight-words'
import renderHighlightedText from './renderHighlightedText'
import { hasRealContent, renderPlanSuggestionContent, toBulletItems, toBulletItemsFromBulletText } from '../../utils/showBulletPoint'
import { formatPhysicalExaminationHTML } from '../../utils/physicalExaminationFormatter'
import { renderAssessmentSuggestionHtml } from '../../utils/assessmentPlanSuggestions'

export const physicalExaminationData = GESelectedData.data

const topLevelBulletListStyle = 'margin:0;padding-left:15px;'
const topLevelBulletItemStyle = 'margin:0 0 2pt 0;line-height:1.15;'
const nestedBulletContentStyle = 'margin:0;padding:0;line-height:normal;'
const patientNoteEditorStyles = `
  [data-theme='dark'] .patient-note-html-editor .rsw-editor,
  [data-theme='dark'] .patient-note-html-editor .rsw-ce,
  [data-theme='dark'] .patient-note-html-editor .rsw-toolbar {
    background: #191919 !important;
    border-color: #2f2f2f !important;
  }

  [data-theme='light'] .patient-note-html-editor .rsw-editor,
  [data-theme='light'] .patient-note-html-editor .rsw-ce,
  [data-theme='light'] .patient-note-html-editor .rsw-toolbar {
    background: #ffffff !important;
    border-color: #d9dee7 !important;
  }

  [data-theme='dark'] .patient-note-html-editor .rsw-ce,
  [data-theme='dark'] .patient-note-html-editor .rsw-ce div,
  [data-theme='dark'] .patient-note-html-editor .rsw-ce p,
  [data-theme='dark'] .patient-note-html-editor .rsw-ce span,
  [data-theme='dark'] .patient-note-html-editor .rsw-ce strong,
  [data-theme='dark'] .patient-note-html-editor .rsw-ce b,
  [data-theme='dark'] .patient-note-html-editor .rsw-ce em,
  [data-theme='dark'] .patient-note-html-editor .rsw-ce i,
  [data-theme='dark'] .patient-note-html-editor .rsw-ce u,
  [data-theme='dark'] .patient-note-html-editor .rsw-ce li,
  [data-theme='dark'] .patient-note-html-editor .rsw-ce ul,
  [data-theme='dark'] .patient-note-html-editor .rsw-ce ol,
  [data-theme='dark'] .patient-note-html-editor .rsw-ce h1,
  [data-theme='dark'] .patient-note-html-editor .rsw-ce h2,
  [data-theme='dark'] .patient-note-html-editor .rsw-ce h3,
  [data-theme='dark'] .patient-note-html-editor .rsw-ce h4,
  [data-theme='dark'] .patient-note-html-editor .rsw-ce h5,
  [data-theme='dark'] .patient-note-html-editor .rsw-ce h6,
  [data-theme='dark'] .patient-note-html-editor .rsw-ce td,
  [data-theme='dark'] .patient-note-html-editor .rsw-ce th,
  [data-theme='dark'] .patient-note-html-editor .rsw-ce label,
  [data-theme='dark'] .patient-note-html-editor .rsw-ce a,
  [data-theme='dark'] .patient-note-html-editor .rsw-toolbar,
  [data-theme='dark'] .patient-note-html-editor .rsw-btn,
  [data-theme='dark'] .patient-note-html-editor .rsw-dd {
    color: #ffffff !important;
  }

  [data-theme='light'] .patient-note-html-editor .rsw-ce,
  [data-theme='light'] .patient-note-html-editor .rsw-ce div,
  [data-theme='light'] .patient-note-html-editor .rsw-ce p,
  [data-theme='light'] .patient-note-html-editor .rsw-ce span,
  [data-theme='light'] .patient-note-html-editor .rsw-ce strong,
  [data-theme='light'] .patient-note-html-editor .rsw-ce b,
  [data-theme='light'] .patient-note-html-editor .rsw-ce em,
  [data-theme='light'] .patient-note-html-editor .rsw-ce i,
  [data-theme='light'] .patient-note-html-editor .rsw-ce u,
  [data-theme='light'] .patient-note-html-editor .rsw-ce li,
  [data-theme='light'] .patient-note-html-editor .rsw-ce ul,
  [data-theme='light'] .patient-note-html-editor .rsw-ce ol,
  [data-theme='light'] .patient-note-html-editor .rsw-ce h1,
  [data-theme='light'] .patient-note-html-editor .rsw-ce h2,
  [data-theme='light'] .patient-note-html-editor .rsw-ce h3,
  [data-theme='light'] .patient-note-html-editor .rsw-ce h4,
  [data-theme='light'] .patient-note-html-editor .rsw-ce h5,
  [data-theme='light'] .patient-note-html-editor .rsw-ce h6,
  [data-theme='light'] .patient-note-html-editor .rsw-ce td,
  [data-theme='light'] .patient-note-html-editor .rsw-ce th,
  [data-theme='light'] .patient-note-html-editor .rsw-ce label,
  [data-theme='light'] .patient-note-html-editor .rsw-ce a,
  [data-theme='light'] .patient-note-html-editor .rsw-toolbar,
  [data-theme='light'] .patient-note-html-editor .rsw-btn,
  [data-theme='light'] .patient-note-html-editor .rsw-dd {
    color: #111827 !important;
  }

  [data-theme='dark'] .patient-note-html-editor .rsw-btn:hover,
  [data-theme='dark'] .patient-note-html-editor .rsw-btn[aria-pressed='true'],
  [data-theme='dark'] .patient-note-html-editor .rsw-dd:hover {
    background: #252525 !important;
  }

  [data-theme='light'] .patient-note-html-editor .rsw-btn:hover,
  [data-theme='light'] .patient-note-html-editor .rsw-btn[aria-pressed='true'],
  [data-theme='light'] .patient-note-html-editor .rsw-dd:hover {
    background: #f3f4f6 !important;
  }

  [data-theme='dark'] .patient-note-html-editor .rsw-ce::placeholder {
    color: #ffffff !important;
  }

  [data-theme='light'] .patient-note-html-editor .rsw-ce::placeholder {
    color: #6b7280 !important;
  }

  .patient-note-pdf-export-surface,
  .patient-note-pdf-export-surface .control-pane,
  .patient-note-pdf-export-surface .control-section,
  .patient-note-pdf-export-surface .rte-control-section,
  .patient-note-pdf-export-surface .patient-note-html-editor .rsw-editor,
  .patient-note-pdf-export-surface .patient-note-html-editor .rsw-ce,
  .patient-note-pdf-export-surface .patient-note-html-editor .rsw-toolbar {
    background: #ffffff !important;
    border-color: #d9dee7 !important;
    color: #111827 !important;
    font-family: "Times New Roman", Times, serif !important;
    font-size: 11pt !important;
    line-height: 1.35 !important;
    letter-spacing: normal !important;
    opacity: 1 !important;
    text-shadow: none !important;
    -webkit-text-fill-color: #111827 !important;
  }

  .patient-note-pdf-export-surface,
  .patient-note-pdf-export-surface *,
  .patient-note-pdf-export-surface .patient-note-html-editor .rsw-ce,
  .patient-note-pdf-export-surface .patient-note-html-editor .rsw-ce div,
  .patient-note-pdf-export-surface .patient-note-html-editor .rsw-ce p,
  .patient-note-pdf-export-surface .patient-note-html-editor .rsw-ce span,
  .patient-note-pdf-export-surface .patient-note-html-editor .rsw-ce strong,
  .patient-note-pdf-export-surface .patient-note-html-editor .rsw-ce b,
  .patient-note-pdf-export-surface .patient-note-html-editor .rsw-ce em,
  .patient-note-pdf-export-surface .patient-note-html-editor .rsw-ce i,
  .patient-note-pdf-export-surface .patient-note-html-editor .rsw-ce u,
  .patient-note-pdf-export-surface .patient-note-html-editor .rsw-ce li,
  .patient-note-pdf-export-surface .patient-note-html-editor .rsw-ce ul,
  .patient-note-pdf-export-surface .patient-note-html-editor .rsw-ce ol,
  .patient-note-pdf-export-surface .patient-note-html-editor .rsw-ce h1,
  .patient-note-pdf-export-surface .patient-note-html-editor .rsw-ce h2,
  .patient-note-pdf-export-surface .patient-note-html-editor .rsw-ce h3,
  .patient-note-pdf-export-surface .patient-note-html-editor .rsw-ce h4,
  .patient-note-pdf-export-surface .patient-note-html-editor .rsw-ce h5,
  .patient-note-pdf-export-surface .patient-note-html-editor .rsw-ce h6,
  .patient-note-pdf-export-surface .patient-note-html-editor .rsw-ce td,
  .patient-note-pdf-export-surface .patient-note-html-editor .rsw-ce th,
  .patient-note-pdf-export-surface .patient-note-html-editor .rsw-ce label,
  .patient-note-pdf-export-surface .patient-note-html-editor .rsw-ce a,
  .patient-note-pdf-export-surface .patient-note-html-editor .rsw-toolbar,
  .patient-note-pdf-export-surface .patient-note-html-editor .rsw-btn,
  .patient-note-pdf-export-surface .patient-note-html-editor .rsw-dd {
    color: #111827 !important;
    font-family: "Times New Roman", Times, serif !important;
    letter-spacing: normal !important;
    line-height: 1.35 !important;
    opacity: 1 !important;
    text-shadow: none !important;
    filter: none !important;
    -webkit-text-fill-color: #111827 !important;
  }

  .patient-note-pdf-export-shell {
    position: fixed;
    left: -100000px;
    top: 0;
    width: 690px;
    padding: 0;
    box-sizing: border-box;
    background: #ffffff !important;
    z-index: -1;
    pointer-events: none;
    opacity: 1 !important;
    transform: none !important;
    filter: none !important;
  }

  .patient-note-pdf-export-shell .patient-note-pdf-export-surface {
    width: 100%;
    background: #ffffff !important;
    padding: 0;
    box-sizing: border-box;
    opacity: 1 !important;
    transform: none !important;
    filter: none !important;
  }
`
const renderNestedBulletContent = (content) =>
  hasRealContent(content)
    ? `<li style="${topLevelBulletItemStyle}"><div style="${nestedBulletContentStyle}">${content}</div></li>`
    : ''

const sanitizePdfFileNamePart = (value = '') =>
  value
    ?.toString()
    .trim()
    .replace(/[\\/:*?"<>|]+/g, '-')
    .replace(/\s+/g, '')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')

const getAppointmentStartDateForFileName = (startTime = '') => {
  const datePart = startTime?.toString().trim().split(/[ T]/)[0] || ''
  if (!datePart) return ''

  const parts = datePart.replace(/[-_.]/g, '/').split('/')
  if (parts.length !== 3) return datePart

  const [first, second, third] = parts
  const month = first.length === 4 ? second : first
  const day = first.length === 4 ? third : second
  const year = first.length === 4 ? first : third

  return `${month.padStart(2, '0')}_${day.padStart(2, '0')}_${year}`
}

const getPatientNotePdfFileName = (patientData, appointmentStartTime) => {
  const firstInitial = sanitizePdfFileNamePart(patientData?.FirstName?.toString().trim().charAt(0).toUpperCase() || '')
  const lastName = sanitizePdfFileNamePart(patientData?.LastName || '')
  const patientName = `${firstInitial}${lastName}` || sanitizePdfFileNamePart(patientData?.PatientID || 'PatientNote')
  const appointmentStartDate = getAppointmentStartDateForFileName(appointmentStartTime)

  return `${appointmentStartDate ? `${patientName}-${appointmentStartDate}` : patientName}.pdf`
}

const PatientNoteViewInModal = ({
  hpiAdded = false,
  setHpiAdded,
  allLabs,
  statusPatientNoteWasFollowUp,
  setRowClicked,
  hpiHeading = '',
  setAppointmentDetails = false,
  showDataIfNoteIsFollowUp,
  patientID,
  setDataId,
  showToolbar = true,
  showMedicationLikeApp,
  showHrsInTreatment,
  showTreatmentAsAccordion,
  diagnosisCode,
  selectedRisks,
  setSelectedRisks,
  MasterDiagnosisData,
  noteStructureRef,
  newmedsAdded,
  newLabsAdded,
  newImagingAdded,
  patientData,
  patientTreatments,
  hospitalRecords,
  patientDiagnosis,
  diagnosisAddedPinger,
  setHospitalRecords,
  patientSidebarActiveTab,
  allergies,
  setAllergies,
  personalHistory,
  setPersonalHistory,
  medication,
  setMedication,
  imaging,
  setImaging,
  activeTab,
  imagingTypeList,
  selectedDifferentialDiagnosis,
  noteShow,
  noteID,
  addendumData,
  isAddendumLoading = false,
  onlyShowHTmlService = true,
}) => {

  console.log("patientNote ID. ", noteID)
  const userData = JSON.parse(localStorage.getItem('user')) || {}
  const role = userData?.Role || ''
  const [modalVisible, setModalVisible] = useState(false)
  const [diagnosis, setDiagnosis] = useState([])
  const [visible, setVisible] = useState(false)
  const [newQuestions, setNewQuestions] = useState([])
  const [formAnswers, setFormAnswers] = useState([])
  const newAnswers = useRef([])
  const [questions, setQuestions] = useState([])
  const [HPIRemarks, setHPIRemarks] = useState('')
  const [diagnosisMedicationMap, setDiagnosisMedicationMap] = useState({})
  const [diagnosisLabMap, setDiagnosisLabMap] = useState({})
  const [diagnosisKeywords, setDiagnosisKeywords] = useState([])
  const [riskfactors, setRiskFactors] = useState({})
  // const [selectedRisks, setSelectedRisks] = useState([]);
  const [allHistoriesList, setAllHistoriesList] = useState([])
  const [masterMedications, setMasterMedications] = useState([])
  const [peData, setPeData] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [isInitialNoteDataReady, setIsInitialNoteDataReady] = useState(false)
  const [isNotePreviewLoading, setIsNotePreviewLoading] = useState(true)
  const [isPdfExporting, setIsPdfExporting] = useState(false)
  const notePreviewReadyTimerRef = useRef(null)

  const toggleRiskSelection = (risk) => {
    setSelectedRisks((prevState) => (prevState.includes(risk) ? prevState.filter((r) => r !== risk) : [...prevState, risk]))
  }

  const filterEmptyData = (data) => {
    return data
      .map((item) => {
        const filteredData = item.data
          .map((dataItem) => {
            const filteredDataItem = {}

            for (const [key, value] of Object.entries(dataItem)) {
              // Skip if value is empty string
              if (value === '') {
                continue
              }

              // Skip if value is empty array
              if (Array.isArray(value) && value.length === 0) {
                continue
              }

              // Keep the property if it's not empty
              filteredDataItem[key] = value
            }

            return filteredDataItem
          })
          .filter((dataItem) => Object.keys(dataItem).length > 0) // Remove completely empty objects

        return {
          ...item,
          data: filteredData,
        }
      })
      .filter((item) => item.data.length > 0) // Remove items with no data
  }

  const getRisks = async (diagnosisList) => {
    let responseRisks = await GetDiagnosisData('Risks')

    try {
      // risks = JSON.parse(risks);
      let risks = JSON.parse(responseRisks.d)?.Data

      // let  = localStorage.getItem("Risks")
      let allRisks = {}

      // Iterate over each diagnosis

      diagnosisList?.forEach((diagnosis) => {
        // Find the risk object that matches the diagnosis name

        let riskObj = risks.find((obj) => obj.Name.trim() == diagnosis.trim())

        if (riskObj) {
          // Assign the risks to the corresponding diagnosis name in the allRisks object
          allRisks[diagnosis] = riskObj.RiskFactors.split(',')
        } else {
          // If no risks found for the diagnosis, you can initialize it as an empty array or handle it accordingly
          allRisks[diagnosis] = []
        }
      })

      setRiskFactors(allRisks)
    } catch (e) {
      console.error('Failed to parse risks from local storage', e)
    }
  }

  // setRowClicked

  const [patientExtraData, setPatientExtraData] = useState({})

  const getAppointmentDetails = async () => {
    // if(!setAppointmentDetails) {
    //     setPatientExtraData({
    //             providerAssigned : noteStructureRef.current?.appointmentDetails?.data?.ProviderName || "",
    //             patientTerm : noteStructureRef.current?.appointmentDetails?.data?.term || "",
    //             scheduleStartTime : noteStructureRef.current?.appointmentDetails?.data?.StartTime || "",
    //         })
    //     return
    // };
    try {
      const structuredData = await getAllAppointmentsDetails('GET')
      //   const findAppointment = structuredData.find((item) => item?.data?.PatientID === patientData.PatientID && (item?.data?.Status === 'Scheduled' || item?.data?.Status === 'Rescheduled') && item?.data?.NoteID === setDataId)
      const findAppointment = structuredData.find(
        (item) => item?.data?.PatientID === patientData?.PatientID && item?.data?.NoteID === setDataId,
        // && (item?.data?.Status === "Scheduled" || item?.data?.Status === "Rescheduled")
        //  && (item?.data?.Status === "Scheduled" || item?.data?.Status === "Rescheduled")
        //  && item?.data?.NoteID === setDataId
      )

      if (findAppointment) {
        setPatientExtraData({
          providerAssigned: findAppointment?.data?.ProviderName || '',
          patientTerm: findAppointment?.data?.term || '',
          scheduleStartTime: findAppointment?.data?.StartTime || '',
        })
      }
    } catch (error) {
      console.log(error)
    }
    // if (findIsThereAnySubmiitedOrSigned) {
    // const findAppointment = appointment.find((item) => item?.data?.PatientID === patient?.PatientID)

    // if (findAppointment) {
    //   const noteIdForthisAppointment = findAppointment?.data?.NoteID
    //   const findNote = parsedData.find((item) => item?.id === noteIdForthisAppointment)
    //   if (findNote) {
    //     status = findNote?.status || status
    //     flag = findNote?.flag || 'false'
    //   }
    // }
  }

  useEffect(() => {
    getAppointmentDetails()
  }, [])

  const patientNotePdfFileName = getPatientNotePdfFileName(
    patientData,
    patientExtraData?.scheduleStartTime || patientData?.scheduleStartTime || noteStructureRef?.current?.appointmentDetails?.data?.StartTime || '',
  )

  const formioOptions = {
    readOnly: true,
    renderMode: 'html',
  }
  const AddDiagnosis = () => {
    setVisible(true)
  }
  const HPIButtons = [{ name: '+ Add Diagnosis', fn: AddDiagnosis }]

  const historyMapping = {
    pmhx: 'Past Medical History',
    pshx: 'Past Surgical History',
    fh: 'Family History',
    sh: 'Social History',
  }
  const formatDate = (inputDate) => {
    if (!inputDate) return ''
    const dateObj = new Date(inputDate)
    const mm = String(dateObj.getMonth() + 1).padStart(2, '0')
    const dd = String(dateObj.getDate()).padStart(2, '0')
    const yyyy = dateObj.getFullYear()
    return `${mm}/${dd}/${yyyy}`
  }

  const historyObjectKeysParticular = {
    pmhx: 'MedicalHistory',
    pshx: 'SurgicalHistory',
    fh: 'FamilyHistory',
    sh: 'SocialHistory',
  }

  const formData = useRef([])
  const [diagnosisData, setDiagnosisData] = useState([])

  const getDataDiagnosis = async () => {
    let a = await GetDiagnosisData()

    let data = JSON.parse(a.d)
    let options = []
    let keywords = []
    data.Data.map((obj) => {
      if (obj.Keywords && obj.Keywords != '') {
        let keywordList = obj.Keywords.split(',')
        keywords.push(...keywordList)
      }

      options.push({
        value: obj.id,
        label: obj.Name.trim(),
      })
    })

    setDiagnosisKeywords(keywords)
    setDiagnosisData(options)
  }

  var selectedDiagnosis = 0

  const diagnosisChanged = async (e) => {
    selectedDiagnosis = e.label
  }

  const handleModalSave = async () => {
    try {
      let newDiagnosis = selectedDiagnosis
      setDiagnosis((prevDiagnosis) => [...prevDiagnosis, newDiagnosis])
      try {
        let c = await GetQuestionBank('', newDiagnosis, '')
        let component = JSON.parse(c?.d)

        let temp = [component]

        setNewQuestions((prev) => [...prev, component])

        newAnswers.current.push([])
      } catch (e) {}
    } catch (e) {
      console.log('Error Saving Diagnosis Data', e.Message)
    }

    setVisible(false)
  }

  useEffect(() => {
    getDataPersonalHistoryInNote()
  }, [patientID])

  const [allTreamentStatements, setAllTreatmentStatements] = useState({})
  const getTreatmentPlansData = async () => {
    let data = await SaveExtra('Get_By_Type', 'generalPlanStatements', '', '')
    const sturcturedTreatments = {}
    data = JSON.parse(data.d)?.Data || []
    if (data) {
      data = data?.map((item) => {
        return {
          Id: item.Id,
          Data: JSON.parse(item?.JsonData),
        }
      })
      patientDiagnosis.forEach((diagnosis) => {
        const matched = data?.length > 0 && data?.find((item) => item.Data?.diagnosis?.label === diagnosis)
        if (matched) {
          const suggestionNames = matched.Data.accordions.flatMap((accordion) => accordion?.suggestions?.suggestionName || []).map((s) => s.name)
          const joinedStatements = suggestionNames?.join('\n')
          sturcturedTreatments[diagnosis] = joinedStatements
        }
      })
      setAllTreatmentStatements(sturcturedTreatments)
    }
  }

  useEffect(() => {
    getTreatmentPlansData()
  }, [patientDiagnosis])

  const getDataPersonalHistoryInNote = async () => {
    let history = {}

    for (const [key, value] of Object.entries(historyObjectKeysParticular)) {
      let allData = await getPatientPersonalHistory('GET', patientID, value, '')

      const formattedData = JSON.parse(allData?.d)

      history[key] = formattedData?.Data
    }

    setPersonalHistory(history)
  }

  useEffect(() => {
    const metadata = noteStructureRef?.current?.metadata || {}

    const allHistories = Object.keys(personalHistory)
      .map((key) => {
        const histories = personalHistory[key] || []
        const matchingEntry = histories.find((item) => item.Id === metadata[historyObjectKeysParticular[key]])

        return matchingEntry
          ? {
              heading: historyMapping[key],
              entry: matchingEntry[historyObjectKeysParticular[key]],
            }
          : null
      })
      .filter(Boolean) // remove nulls

    setAllHistoriesList(allHistories)
  }, [personalHistory])

  const getCallCenterData = async (diagnosisList) => {
    setLoading(true)
    let newComponents = []
    let tempAnswers = await GetPatientDiagnosisDetails(patientData.PatientID)
    try {
      let data = JSON.parse(tempAnswers.d)
      let formAnswersStr = data.Data[0].DiagnosisDetails
      let tempData = JSON.parse(formAnswersStr)

      setFormAnswers(tempData)
    } catch (e) {}
    for (let a = 0; a < diagnosisList?.length; a++) {
      try {
        formData.current.push([])
        try {
          let component = []
          let c = await GetQuestionBank('', diagnosisList[a], '')

          component = JSON.parse(c?.d)
          newComponents.push(component)
        } catch (e) {}
      } catch (e) {
        console.log('Error Fetching Diagnosis Data: ', diagnosisList[a], e)
      }
    }
    setQuestions(newComponents)
    setLoading(false)
  }

  const sortImagingData = (data) => {
    const sortedByPriority = data.sort((a, b) => {
      // Compare by priority
      if (a.priority !== b.priority) {
        return a.priority - b.priority
      }
      // If priority is the same, compare by date
      return new Date(b.date) - new Date(a.date)
    })
    return sortedByPriority
  }

  const groupImagingByDiagnosis = (imagingData) => {
    const groupedData = {}
    const diagnosisMap = {}
    diagnosisData.forEach((d) => {
      diagnosisMap[d.value] = d.label
    })
    imagingData.forEach((imaging) => {
      imaging.otherDetails.forEach((detail) => {
        const diagnosisName = diagnosisMap[detail.diagnosis]
        if (diagnosisName) {
          if (!groupedData[diagnosisName]) {
            groupedData[diagnosisName] = []
          }
          groupedData[diagnosisName].push({
            date: imaging.date,
            impression: imaging.impression,
            keywords: imaging.keywords,
            name: imaging.name,
            remark: detail.remarks,
          })
        }
      })
    })
    return groupedData
  }

  function createDiagnosisMedicationMap(data) {
    const diagnosisMedicationMap = {}

    const entryDate = data.date
    for (const medication of data.medications) {
      if (medication.diagnosis) {
        const diagnoses = medication.diagnosis.split(',')

        for (const diagnosis of diagnoses) {
          if (!diagnosisMedicationMap[diagnosis]) {
            diagnosisMedicationMap[diagnosis] = {
              date: entryDate,
              medications: [],
            }
          }
          diagnosisMedicationMap[diagnosis].medications.push(medication)
        }
      }
    }

    return diagnosisMedicationMap
  }

  const filterLabsByDiagnosis = (labs) => {
    const diagnosisGroups = {}

    labs?.forEach((labEntry) => {
      labEntry.labs.forEach((lab) => {
        if (lab.diagnosis) {
          const diagnoses = lab.diagnosis.split(',')
          const labDate = new Date(labEntry.date)

          diagnoses.forEach((diagnosis) => {
            diagnosis = diagnosis.trim()
            if (!diagnosisGroups[diagnosis]) {
              diagnosisGroups[diagnosis] = { date: labEntry.date, labs: [lab] }
            } else {
              const existingDate = new Date(diagnosisGroups[diagnosis].date)
              if (labDate > existingDate) {
                diagnosisGroups[diagnosis] = { date: labEntry.date, labs: [lab] }
              } else if (labDate.getTime() === existingDate.getTime()) {
                diagnosisGroups[diagnosis].labs.push(lab)
              }
            }
          })
        }
      })
    })

    return diagnosisGroups
  }

  const getLabs = () => {
    let noteLabs = localStorage.getItem('notesLabs')
    try {
      let labs = JSON.parse(noteLabs)

      if (labs) {
        let diagnosisMap = filterLabsByDiagnosis(labs)
        setDiagnosisLabMap(diagnosisMap)
      }
    } catch (e) {}
  }

  const getMedication = () => {
    //     const storedMedications = JSON.parse(localStorage.getItem('patientMedications')) || {};
    //     setMedication(storedMedications[patientID] || []);
    //     let patientMedication = storedMedications[patientID] || []
    //     localStorage.setItem("allMedication", JSON.stringify(patientMedication.length > 0 ? patientMedication[patientMedication.length - 1] : {})) //both dooing the same thing
  }

  useEffect(() => {
    getMedication()
    getLabs()
  }, [diagnosisData.length])

  const getHistory = async () => {
    let allData = await ModifyPatientHistory('GET', patientID)
    let history = JSON.parse(allData?.d)
    setHospitalRecords(history?.Data)
    let allHistory = history?.Data
    if (allHistory.length > 0) {
      localStorage.setItem('PatientHospitalRecords', allHistory[allHistory.length - 1].History)
    } else {
      localStorage.setItem('PatientHospitalRecords', '')
    }
  }

  useEffect(() => {
    setLoading(true)
    getHistory()
    getDataDiagnosis()
    let diagnosis = patientData?.Diagnosis
    let diagnosisList = diagnosis?.split(',')
    setDiagnosis(diagnosisList)

    // getCallCenterData(diagnosisList)
    getRisks(diagnosisList)
    GetMasterMedications()
    setLoading(false)
  
  }, [patientID, diagnosisAddedPinger])

  // const getAllergies = () => {
  //     try {
  //         const storedData = JSON.parse(localStorage.getItem('patientAllergies')) || {};
  //         const patientAllergies = storedData[patientID] || []
  //         setAllergies(patientAllergies);
  //         let temp = []
  //         if (storedData[patientID] && storedData[patientID].length > 0) {
  //             temp = storedData[patientID]
  //         }
  //         localStorage.setItem('noteAllergies', JSON.stringify(temp));
  //     } catch (e) {
  //     }
  // }

  // get master medications
  const GetMasterMedications = async () => {
    try {
      let allMedicines = await MedicineCRUD('GET')
      let formattedData = JSON.parse(allMedicines.d)?.Data
      if (formattedData) {
        formattedData = formattedData.map((item) => {
          let itemData = JSON.parse(item.Data)
          return {
            ...item,
            Data: {
              ...itemData,
              diagnoses: itemData.diagnoses.split(',').map((diagnosis) => diagnosis.trim()),
            },
          }
        })

        setMasterMedications(formattedData)
      }
    } catch (error) {
      console.error('Error fetching master medications:', error)
    }
  }

  const getDiagnosisMedicationInRisk = (diagnosisName) => {
    if (masterMedications.length > 0) {
      const lastMedicationAdded = medication[medication.length - 1]
      if (!lastMedicationAdded) return
      const { data } = lastMedicationAdded
      const matchingDiagnoses = data.map((med) => {
        const matchingMasterMed = masterMedications.find((item) => item.Data.name === med.name)
        return matchingMasterMed
      })
      let name
      matchingDiagnoses.find((item) => {
        if (item?.Data.diagnoses.includes(diagnosisName)) {
          name = item.Data
        }
      })
      noteStructureRef.current = {
        ...noteStructureRef.current,
      }
      return name // we are shouwing the data of master medication which doesn't has any date.
    } else {
      return 'Not enough information'
    }
  }

  const hasAnyAnswer = (data) => {
    return Object.values(data).some((value) => {
      return typeof value === 'string' && value.trim() !== ''
    })
  }

  // Pdf part
  const { toPDF, targetRef } = usePDF({
    filename: patientNotePdfFileName,
    resolution: Resolution.MEDIUM,
    page: {
      margin: {
        top: 10,
        right: 14,
        bottom: 10,
        left: 14,
      },
    },
    canvas: {
      mimeType: 'image/jpeg',
      qualityRatio: 0.95,
    },
    overrides: {
      canvas: {
        backgroundColor: '#ffffff',
        scale: Resolution.MEDIUM,
      },
    },
  })

  // Provider Final Note Part

  const [patientFinalNoteHpi, setPatientFinalNoteHpi] = useState({})
  const [patientHpiOtherData, setPatientHpiOtherData] = useState({
    medicationRemarksForSubjective: '',
    data: '',
  })

  const getLatestNoteByPatientAndNoteID = (allPatientHpiData, patientID, noteID) => {
    const filtered = allPatientHpiData.filter((item) => {
      const patientData = item[patientID]
      return patientData && patientData[noteID]
      // return patientData
    })

    const latest = filtered.at(-1)
    return latest || null
  }
  const [subjective, setSubjective] = useState([])

  const [newFreeTypeText, setNewFreeTypeText] = useState('')
  const fetchPatientFinalNoteDetails = async () => {
    try {
      let data = await SaveExtra('Get_By_Type', 'PatientHPI', '', '')
      let allData = JSON.parse(data?.d)

      const allPatientHpiData = allData?.Data?.map((item) => {
        return {
          ...JSON.parse(item?.JsonData),
          CreatedAt: item?.CreatedAt,
        }
      })

      const result = getLatestNoteByPatientAndNoteID(allPatientHpiData, patientID, noteID)
      setSubjective(result[patientID])

      try {
        const hpiData = result?.[patientID]?.[noteID]?.HPI || {}
        const newFreeTypeText = result?.[patientID]?.[noteID]?.newFreeTypeText || ''
        if (newFreeTypeText) {
          setNewFreeTypeText(newFreeTypeText || '')
        }
        setPatientFinalNoteHpi(hpiData)
      } catch (error) {
        console.error('Error setting patient HPI:', error)
      }
      //     const filteredByPatient = allPatientHpiData?.filter(item => item?.PatientID ===  patientID);

      //     const latestPatientHPI = filteredByPatient?.sort((a, b) => new Date(b?.CreatedAt) - new Date(a?.CreatedAt))[0];

      //     if(latestPatientHPI?.medicationRemarksForSubjective){
      //         setPatientHpiOtherData((p)=>({
      //             ...p,
      //             medicationRemarksForSubjective:latestPatientHPI?.medicationRemarksForSubjective
      //         }))
      //     }

      //     if(latestPatientHPI?.data){
      //         setPatientHpiOtherData((p)=>({
      //             ...p,
      //             data:latestPatientHPI?.data
      //         }))
      //     }
      //  setPatientFinalNoteHpi(latestPatientHPI?.HPI)
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    fetchPatientFinalNoteDetails()
  }, [hpiAdded, patientID, noteID])

  // Patient Vitals
  const vitalFields = [
    { name: 'BloodPressure', label: 'Blood Pressure', unit: 'mmHg' },
    { name: 'HeartRate', label: 'Heart Rate', unit: 'bpm' },
    { name: 'RespiratoryRate', label: 'Respiratory Rate', unit: 'rpm' },
    { name: 'Temperature', label: 'Temperature', unit: '°F' },
    { name: 'SpO2', label: 'SpO2', unit: '%' },
    { name: 'InhaledO2', label: 'Inhaled O2', unit: '%' },
    { name: 'HeartCirc', label: 'Heart Circ', unit: 'in' },
    { name: 'Height', label: 'Height', unit: 'ft/in' },
    { name: 'Weight', label: 'Weight', unit: 'lbs/oz' },
  ]
  const [vitalsList, setVitalsList] = useState([])
  const getPatientVitals = async () => {
    let allVital = { PatientID: patientID }
    allVital = [allVital]
    let allData
    allData = await fetchPatientData('GET', 'Vitals', JSON.stringify(allVital))
    allData = JSON.parse(allData.d) || {}

    setVitalsList(allData?.Data)
  }

  useEffect(() => {
    getPatientVitals()
  }, [])

  // PE

  const [finalHtml, setFinalHtml] = useState('')

  const [loading, setLoading] = useState(false)
  useEffect(() => {
    let isMounted = true

    const loadInitialNotePreview = async () => {
      const diagnosisList = patientData?.Diagnosis?.split(',').filter(Boolean) || []

      setIsInitialNoteDataReady(false)
      setIsNotePreviewLoading(true)
      setLoading(true)
      setDiagnosis(diagnosisList)

      const previewTasks = [
        () => getDataDiagnosis(),
        () => getTreatmentPlansData(),
        () => getDataPersonalHistoryInNote(),
        () => getMedication(),
        () => getLabs(),
        () => getPatientVitals(),
        () => getHistory(),
        () => GetMasterMedications(),
        () => fetchPatientFinalNoteDetails(),
        () => PEData(),
        () => fetchOrders(),
        () => getFacilities(),
      ]

      if (diagnosisList.length > 0) {
        previewTasks.push(() => getRisks(diagnosisList))
      }

      if (Array.isArray(patientDiagnosis) && patientDiagnosis.length > 0) {
        previewTasks.push(() => getCallCenterDatas(patientDiagnosis))
      }

      await Promise.allSettled(previewTasks.map((task) => Promise.resolve().then(task)))

      if (!isMounted) return
      setIsInitialNoteDataReady(true)
      setLoading(false)
    }

    loadInitialNotePreview()

    return () => {
      isMounted = false
      if (notePreviewReadyTimerRef.current) {
        clearTimeout(notePreviewReadyTimerRef.current)
      }
    }
  }, [patientID, noteID, setDataId])

  const [ddxHtml, setDdxHtml] = useState({})

  useEffect(() => {
    const fetchDdx = async () => {
      try {
        const response = await axios.get('https://api.jsonbin.io/v3/b/6802025b8a456b79668c0939', {
          headers: {
            'X-Master-Key': '$2a$10$tHFyzLeQFlPNXCUKVZKoHOYcQ.w6mvUkF6LYxXaanjZFVBcIRPppG',
          },
        })

        const records = response?.data?.record
        const patientNotes = records?.patientData?.[patientID]

        if (Array.isArray(patientNotes)) {
          const findNote = patientNotes.find((item) => item.noteId === setDataId)
          if (findNote) {
            const treatmentsShellNote = findNote['Treatment Shell']
            if (treatmentsShellNote) {
              patientDiagnosis.forEach((diagnosis) => {
                const ddx = treatmentsShellNote[diagnosis]
                if (ddx?.ddx) {
                  setDdxHtml((prev) => ({
                    ...prev,
                    [diagnosis]: ddx.ddx,
                  }))
                } else {
                  console.log(`${diagnosis} ke liye nahi aaya ddx`)
                }
              })
            }
          } else {
            console.log(' No matching note found for setDataId')
          }
        } else {
          console.log(' No notes found for this patient')
        }
      } catch (error) {
        console.error('❌ Axios Error:', error)
      }
    }

    fetchDdx()
  }, [patientID, setDataId, patientDiagnosis])

  const PEData = async () => {
    try {
      let peData = await fetchData()
      if (peData.length > 0) {
        setFinalHtml(formatPhysicalExaminationHTML(peData))
      }
    } catch (err) {
      console.log(err, 'pe error')
    }
  }
  // useEffect(() => {
  //     const fetchDataPE = async () => {
  //         try {
  //             await PEData();
  //         } catch (error) {
  //             console.error("Error fetching PEData:", error);
  //         }
  //     };

  //     fetchDataPE();
  // }, []);

  useEffect(() => {
    setLoading(true)
    PEData()
    setLoading(false)
  }, [])

  // poa
  const [questionValue, setQuestionsValue] = useState([])
  const [newComponents, setNewComponents] = useState([])
  const [dataWithoutValues, setDataWithoutValues] = useState([])
  const [formValue, setFormValues] = useState([])

  let tempData = []
  const filterEmptyAnswers = (data) => {
    return data
      .filter((item) => typeof item === 'object' && !Array.isArray(item))
      .map((item) => {
        return {
          ...item,
          data: Object.fromEntries(Object.entries(item.data).filter(([key, value]) => value !== '')),
        }
      })
  }

  const [orders, setOrders] = useState({})

  const fetchOrders = async () => {
    try {
      let data = await PatientOrdersCRUD('Get', '', patientID)
      data = JSON.parse(data?.d)
      const parsedOrders = data?.Data.map((order) => ({
        ...order,
        medication: JSON.parse(order.medication),
      }))

      const groupedOrders = {}
      parsedOrders.forEach((order) => {
        const diagnosis = order.medication.diagnosis
        if (!groupedOrders[diagnosis]) {
          groupedOrders[diagnosis] = []
        }
        groupedOrders[diagnosis].push({
          date: order?.date,
          imaging: order.medication.imaging,
          lab: order.medication.lab,
          medication: order.medication.medication,
          miscellaneous: order.medication.miscellaneous,
          noteID: order?.medication?.noteID,
        })
      })

      setOrders(groupedOrders)
    } catch (error) {
      console.error('Failed to fetch or parse orders:', error)
    }
  }

  useEffect(() => {
    fetchOrders()
  }, [])

  // const getCallCenterDatas = async (diagnosisList) => {
  //   setLoading(true)
  //   let tempAnswers = await GetPatientDiagnosisDetails(patientData.PatientID)
  //   try {
  //     let data = JSON.parse(tempAnswers.d)
  //     let formAnswersStr = data.Data[0].DiagnosisDetails
  //     let tempData = JSON.parse(formAnswersStr)
  //     let resultData = filterEmptyAnswers(tempData)
  //     setDataWithoutValues(resultData.map((item) => item.data).reduce((acc, obj) => ({ ...acc, ...obj }), {}))
  //     setFormAnswers(tempData)
  //     setFormValues(resultData)
  //   } catch (e) {}
  //   const updatedComponents = []

  //   for (let a = 0; a < diagnosisList?.length; a++) {
  //     try {
  //       formData.current.push([])
  //       try {
  //         let component = []
  //         let c = await GetQuestionBank('', diagnosisList[a], '')
  //         if (c && c.d) {
  //           component = JSON.parse(c?.d)

  //           updatedComponents.push({ diagnosis: diagnosisList[a], component: component })
  //         }
  //       } catch (e) {
  //         console.log('error====>', e)
  //       }
  //     } catch (e) {
  //       console.log('Error Fetching Diagnosis Data: ', diagnosisList[a], e)
  //     }
  //   }

  //   setNewComponents(updatedComponents)
  //   setLoading(false)
  // }

  const getLatestDataForPoa = (allPatientHpiData, patientID) => {
    const filtered = allPatientHpiData.filter((item) => {
      const patientData = item[patientID]
      // /  return patientData && patientData[noteID]
      return patientData
    })

    const latest = filtered.at(-1)
    return latest || null
  }

  const [freeTypeGlobal, setFreeTypeGlobal] = useState('')
  const getCallCenterDatas = async (diagnosisList) => {
    let data = await SaveExtra('Get_By_Type', 'CallCenterQuestions', '', '')
    let allData = JSON.parse(data?.d)

    const allPatientHpiData = allData?.Data?.map((item) => {
      return {
        ...JSON.parse(item?.JsonData),
        CreatedAt: item?.CreatedAt,
      }
    })

    const result = getLatestDataForPoa(allPatientHpiData, patientID)

    const convertedData = {}

    const callCenterData = result?.[patientID]?.CCENTER
    const globalFreeType = result?.[patientID]?.globalFreeType
    if (callCenterData) {
      Object.keys(callCenterData).forEach((diagnosis) => {
        convertedData[diagnosis] = callCenterData[diagnosis]?.map((q) => ({
          question: q.label,
          answer: q.answer,
          freeType: q.freeType,
          type: q?.type,
          freewayRemark: q?.freewayRemark,
        }))
      })
    }
    setFreeTypeGlobal(globalFreeType)

    setQuestionsValue(convertedData)

    return convertedData
  }
  useEffect(() => {
    if (Array.isArray(patientDiagnosis) && patientDiagnosis.length > 0) {
      getCallCenterDatas(patientDiagnosis)
    }
  }, [patientDiagnosis])

  const [incidentRemarkGlobal, setIncidentRemarkGlobal] = useState('')
  useEffect(() => {
    if (noteStructureRef.current.incidentRemark) {
      setIncidentRemarkGlobal(noteStructureRef.current.incidentRemark || '')
    }
  }, [])
  // Get Facility Information
  const [patientFacilityData, setPatientFacilityData] = useState({})
  const getFacilities = async () => {
    let a = await FacilityCRUD('SELECT', {})
    let data = JSON.parse(a.d)?.Data
    try {
      if (patientData?.FacilityName) {
        let facility = data.find((item) => item.Name === patientData?.FacilityName)
        if (facility) {
          setPatientFacilityData(facility)
        } else {
          console.log('Facility not found')
        }
      } else {
        console.log('patientData?.FacilityName not found')
      }
    } catch (e) {}
  }

  const [peGlobalRemark, setPeGlobalRemark] = useState('')
  const fetchData = async () => {
    let lastGeneralExamination = []
    let lastLastDiagnosisExamination = []
    let response = await PatientPhysicalExaminationData('Get_By_Patient', patientID, noteID)
    const parsedData = JSON.parse(response.d).Data || []
    const findLastDiagnosisExaminationData = parsedData.filter((item) => item.Type === 'DiagnosisExaminationData' && item?.NoteID === noteID?.toString()) || []
    const findLastGeneralDiagnosisExamination = parsedData.filter((item) => item.Type === 'GeneralExaminationData' && item?.NoteID === noteID?.toString()) || []
    const globalRemarks = parsedData.filter((item) => item.Type === 'PhysicalExaminationGlobalRemark' && item?.NoteID === noteID?.toString())
    const lastGlobalRemark = globalRemarks[globalRemarks.length - 1] || null

    const jsonRemarkGlobalRemark = lastGlobalRemark ? JSON.parse(lastGlobalRemark.JsonData) : null
    setPeGlobalRemark(jsonRemarkGlobalRemark?.globalRemarkText || '')

    if (findLastGeneralDiagnosisExamination.length > 0) {
      lastGeneralExamination = JSON.parse(findLastGeneralDiagnosisExamination[findLastGeneralDiagnosisExamination.length - 1]?.JsonData) || []
    }
    if (findLastDiagnosisExaminationData.length > 0) {
      lastLastDiagnosisExamination = JSON.parse(findLastDiagnosisExaminationData[findLastDiagnosisExaminationData.length - 1]?.JsonData) || []
    }
    if (lastGeneralExamination.length > 0 || lastLastDiagnosisExamination.length > 0) {
      // setPeData([...lastGeneralExamination, ...lastLastDiagnosisExamination])
    }

    return [...lastGeneralExamination, ...lastLastDiagnosisExamination]
  }

  // useEffect(() => {
  //     fetchData()
  // }, [])

  useEffect(() => {
    getFacilities()
  }, [patientData])
  const [textareaInputValue, setTextareaInputValue] = useState('')

  useEffect(() => {
    // let lastHospitalRecord = hospitalRecords?.find((item) => item.Id === noteStructureRef.current?.metadata?.historyId)?.History ? `${hospitalRecords?.find((item) => item.Id === noteStructureRef.current?.metadata?.historyId)?.History}` : ''
    // let lastHistoryId = noteStructureRef?.current?.metadata?.historyId
    // let highlightsArr = noteStructureRef.current?.highlightDetails?.[lastHistoryId] || []
    // lastHospitalRecord = lastHospitalRecord.trim().replace(/\n/g, '<br/>')

    // // apply highlights
    // highlightsArr.forEach((word) => {
    //   if (word) {
    //     const regex = new RegExp(`(${word})`, 'gi')
    //     lastHospitalRecord = lastHospitalRecord.replace(regex, `<span style="font-weight:bold;">$1</span>`)
    //   }
    // })

    const keyOfallHistoriesList = {
      'Past Medical History': 'PMHx',
      'Past Surgical History': 'PSHx',
      'Family History': 'FHx',
      'Social History': 'SHx',
    }

    const formattedHistories =
      Array.isArray(allHistoriesList) && allHistoriesList.length > 0
        ? `
<table style="width: 100%; font-size: 11pt; border-collapse: collapse; margin-top: 10pt;">
${allHistoriesList
  .map(
    (history) => `
<tr style="vertical-align: top;">
<td style="width: 30%; border: 0; font-weight: bold; font-size: 13pt; padding: 6px 0; vertical-align: top;">
${keyOfallHistoriesList[history?.heading] || ''}
</td>
<td style="width: 70%; white-space: pre-line; border: 0; padding: 6px 4px;">${history?.entry?.trim() || ''}</td>
</tr>
`,
  )
  .join('')}
</table>
`
        : ''

    //         const formattedAllergies =
    //             allergies?.length > 0
    //                 ? `
    //   <table style="width: 100%; font-size: 11pt; border-collapse: collapse; margin-bottom: 10px;">
    //     ${allergies
    //                     .filter(item =>
    //                         noteStructureRef?.current?.metadata?.allergiesIds?.includes(item.id)
    //                     )
    //                     .map(
    //                         (item, idx) => `
    //             <tr style="vertical-align: top;">

    //               ${idx === 0
    //                                 ? `<td rowspan="${allergies.length}" style="width: 30%;border:0; font-weight: bold; font-size: 13pt; padding: 6px 0; vertical-align: top;">Allergies</td>`
    //                                 : ''
    //                             }
    //               <td style="width: 70%; padding: 0px 0px;border:0;">
    //                 <span>Allergen: ${item.data?.allergen || ''}</span>
    //                 <span>Severity: ${item.data?.severity || ''}</span>
    //                 <span>Reaction: ${item.data?.reaction || ''}</span>
    //               </td>
    //             </tr>
    //           `
    //                     )
    //                     .join('')
    //                 }
    //   </table>
    //   `
    //                 : '<div>No allergies</div>';

    const filteredAllergies = allergies?.filter((item) => noteStructureRef?.current?.metadata?.allergiesIds?.includes(item.id)) || []

    const formattedAllergies = `
<table style="width: 100%; font-size: 11pt; border-collapse: collapse; margin-bottom: 10px;">
<tr style="vertical-align: top;">
<td style="width: 30%; border: 0; font-weight: bold; font-size: 13pt; padding: 6px 0; vertical-align: top;">
Allergies
</td>
${
  filteredAllergies.length > 0
    ? `<td style="width: 70%; padding: 6px 0; vertical-align: top; border: 0;">
<div>
${filteredAllergies
  .map(
    (item) => `
  <div style="margin-bottom: 4px; display: flex; gap: 12px;">
<div><span style="font-weight:600;">Allergen:</span> ${item.data?.allergen || ''}</div>
<div><span style="font-weight:600;">Severity:</span> ${item.data?.severity || ''}</div>
<div><span style="font-weight:600;">Reaction:</span> ${item.data?.reaction || ''}</div>
</div>
`,
  )
  .join('')}
</div>
</td>`
    : `<td style="width: 70%; padding: 6px 0; vertical-align: top; border: 0;">Patient Has No Allergies</td>`
}
</tr>
</table>
`

    const linkedVitalId = noteStructureRef?.current?.metadata?.vitalId
    const lastVital = (linkedVitalId && vitalsList?.find((v) => String(v.ID) === String(linkedVitalId))) || vitalsList?.[vitalsList.length - 1]

    let formattedVitals = ''
    if (lastVital) {
      formattedVitals = `

<div>
<span>${lastVital?.Date?.split(' ')[0]?.replace(/\./g, '/')}</span>
<div>
${vitalFields
  .map((field) => {
    return lastVital[field.name] ? `<strong>${field.label}</strong>: ${lastVital[field.name]} ${field.unit || ''}` : ''
  })
  .filter(Boolean)
  .join(', ')}
</div>
</div>
`
    }

    const reviewValue = (noteStructureRef?.current?.reviewOfSystem && noteStructureRef?.current?.reviewOfSystem?.editROS) || ''
    const reviewSystemHtml = reviewValue
      ? `<span style="white-space: pre-wrap;">${reviewValue}
</span>`
      : ''

    // const medEntry = medication[medication.length - 1];
    const medEntry = medication.find((item) => item.id === noteStructureRef.current?.metadata?.medId)
    // const medicationNotes =
    //   medEntry?.data
    //     ?.map((med) => {
    //       return `${med.name} ${med.dosage} ${med.route} ${med.frequency} ${med?.standingTemplateName || ''}`
    //     })
    //     .join('') || ''
      const medicationNotes =
        medEntry?.data
          ?.map((med) => {
            const medText = [med.name, med.dosage, med.route, med.frequency, med?.standingTemplateName].filter(Boolean).join(' ')
            const formattedMedText = med?.inMaster ? `<strong>${medText}</strong>` : medText
            return `<div style="margin:0;">${formattedMedText}</div>`
          })
          .join('') || '' 

    // const hpiNotes = patientDiagnosis.map((diagnosisItem) => {
    //     const hpiData = patientFinalNoteHpi?.[diagnosisItem] || [];
    //     const formattedHpi = hpiData.map((hpi) => `<div><span>${hpi.label}: ${hpi.answer}</span> </div>`).join('');
    //     return `
    //     <div style="margin-bottom: 10px;">
    //         <p style="margin:0;font-weight:700;line-height:22px;font-size:11pt;">${diagnosisItem?.toUpperCase()}</p>
    //         <div>
    //     <div style="">${formattedHpi}</div>
    //         </div>
    //       </div>
    //   `;
    // }).join('') || '';
    // const hpiNotes =
    //   patientDiagnosis
    //     .map((diagnosisItem) => {
    //       const hpiData = patientFinalNoteHpi?.[diagnosisItem] || []

    //       const formattedHpi = hpiData.length > 0 ? hpiData.map((hpi) => `<div><span>${hpi.label}: ${hpi.answer}</span></div>`).join('') : ''

    //       return formattedHpi
    //         ? `
    //                 <div style="margin-bottom: 10px;">

    //                     <p style="margin:0;font-weight:700;line-height:22px;font-size:11pt;">${diagnosisItem?.toUpperCase()}</p>
    //                     <div>${formattedHpi}</div>
    //                 </div>
    //               `
    //         : ''
    //     })
    //     .join('') || ''

    const hpiNotes =
      (patientDiagnosis || [])
        .map((diagnosisItem) => {
          const hpiData = patientFinalNoteHpi?.[diagnosisItem] || []

          // Pick freetype remark only from the first entry
          let freeTypeRemark = ''

          if (hpiData.length > 0 && hpiData[0]?.freewayRemark) {
            freeTypeRemark = `
<div style="padding-left: 10px; color: #444; font-style: italic;">
${hpiData[0]?.freewayRemark}
</div>
`
          }

          const formattedHpi =
            hpiData.length > 0
              ? hpiData
                  .map((hpi) => {
                    const label = hpi?.label || ''
                    const answer = Array.isArray(hpi?.answer) ? hpi.answer.join(', ') : hpi?.answer.split('|||').join(', ') || ''
                    const parentQuestion = hpi?.parentQuestion?.split('-')[1] || ''
                    const nestingDepth = Number.isInteger(hpi?.nestingDepth) && hpi.nestingDepth >= 0 ? hpi.nestingDepth : (hpi?.parentQuestion ? 1 : 0)
                    const freetypeBottomText = hpi?.freeType
                    return `<div style="padding-left: ${10 + nestingDepth * 20}px;">
<span>
    ${parentQuestion !== '' ? `[${parentQuestion}]` : ''} ${label ? `<span style="font-weight:700">${label}</span> : ${answer}` : `${answer}`}

</span>
${freetypeBottomText ? `<div style="">Freetype:  ${freetypeBottomText}</div>` : ''}
</div>`
                  })
                  .join('')
              : ''

          return formattedHpi
            ? `
<div style="margin-bottom: 10px;">
<p style="margin:0;font-weight:700;line-height:22px;font-size:11pt;">
${diagnosisItem?.toUpperCase()}
</p>
${freeTypeRemark}
<div>${formattedHpi}</div>
</div>
`
            : ''
        })
        .join('') || ''

    //this is upper incident all incident
    // let incidentHtmlParentContent = ''

    // patientDiagnosis.forEach((diagnosis) => {
    //   if (noteStructureRef?.current?.incident) {
    //     const allKeys = Object.keys(noteStructureRef?.current?.incident)
    //     // const filteredKeys = allKeys.filter((key) => key?.toLowerCase()?.startsWith(diagnosis))
    //     const filteredKeys = allKeys.filter((key) => key.toLowerCase().startsWith(diagnosis?.toLowerCase()))

    //     const allIncidentsWithDates = filteredKeys.map((key) => {
    //       const date = key.split(`${diagnosis}_`)[1]
    //       return {
    //         date: date,
    //         incidents: noteStructureRef?.current?.incident[key],
    //       }
    //     })

    //     if (allIncidentsWithDates.length > 0) {
    //       const htmlForDiagnosis = allIncidentsWithDates
    //         .map((incident) => {
    //           const itemsHtml =
    //             incident?.incidents && incident?.incidents.length > 0
    //               ? incident?.incidents
    //                   .filter((item) => item.answer)
    //                   .map(
    //                     (item, idx) =>
    //                       `<div>
    //                                     <span class="p-0 m-0">${idx + 1}. ${item.label}</span><br/>
    //                                     <span class="p-0 m-0">Answer: ${item.answer}</span>
    //                                  </div>`,
    //                   )
    //                   .join('')
    //               : ''

    //           return `
    //                     <div>
    //                         <span style="margin:0;padding:0pt;padding:6pt 0pt;">
    //                             <strong>${diagnosis}</strong> - ${new Date(incident?.date).toLocaleDateString('en-US')}
    //                         </span>
    //                                             ${incident?.incidents.length > 0 && incident?.incidents[0]?.freeRemark ? `<p className='py-2' style={{whiteSpace:"pre-line"}}>${incident?.incidents[0]?.freeRemark ? incident?.incidents[0]?.freeRemark : ''}</p> ` : ''}
    //                         ${itemsHtml}
    //                     </div>
    //                 `
    //         })
    //         .join('')

    //       incidentHtmlParentContent += htmlForDiagnosis
    //     }
    //   }
    // })
    let incidentHtmlParentContent = ''

    if (noteStructureRef?.current?.incident) {
      const allKeys = Object.keys(noteStructureRef.current.incident)

      const allIncidents = allKeys.map((key) => {
        const lastUnderscoreIndex = key.lastIndexOf('_')

        const diagnosis = key.substring(0, lastUnderscoreIndex)
        const date = key.substring(lastUnderscoreIndex + 1)

        return {
          diagnosis,
          date,
          incidents: noteStructureRef.current.incident[key],
        }
      })

      allIncidents.forEach((incident) => {
        const itemsHtml =
          incident?.incidents && incident?.incidents.length > 0
            ? incident.incidents
                .filter((item) => item.answer)
                .map(
                  (item, idx) =>
                    `<div>
    <span class="p-0 m-0">${idx + 1}. ${item.label}</span><br/>
    <span class="p-0 m-0">Answer: ${item.answer}</span>
       ${item?.freeType ? `<div style="white-space: pre-wrap;">Freetype:  ${item.freeType}</div>` : ''}
  </div>`,
                )
                .join('')
            : ''

        const freeRemark = incident?.incidents?.length > 0 && incident?.incidents[0]?.freeRemark ? `<p class='py-2' style='white-space:pre-line;'>${incident.incidents[0].freeRemark}</p>` : ''

        incidentHtmlParentContent += `
<div>
<span style="margin:0;padding:6pt 0pt;">
<strong>${incident.diagnosis}</strong> - 
${new Date(incident.date).toLocaleDateString('en-US')}
</span>
${freeRemark}
${itemsHtml}
</div>
`
      })
    }

    // const imagingNote =
    //   imaging
    //     ?.filter((imgEntry) => noteStructureRef?.current?.metadata?.imagingIds?.includes(parseInt(imgEntry.id)))
    //     ?.map((obj) => {
    //       const date = new Date(obj.date).toLocaleDateString('en-US')
    //       const name = obj.data?.name || ''
    //       const impression = obj.data?.impression || ''
    //       return `<div style="margin-bottom: 8px;padding: ;">
    //         <span>${date} - ${name}</span><br/>
    //         <span>Impressions:</span><br/>${impression}
    //       </div>`
    //     })
    //     .join('') || ''

    //this is the new code that is added for the highlight text rendering issue in the note preview modal in the final note section

    const escapeRegex = (str = '') => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

    // const highlightKeywordsHtml = (text = '', keywords = []) => {
    //   if (!text) return ''

    //   let words = []

    //   if (Array.isArray(keywords)) {
    //     words = keywords
    //   } else if (typeof keywords === 'string') {
    //     words = keywords.split(',')
    //   }

    //   words = words
    //     .map(w => String(w).trim())
    //     .filter(Boolean)

    //   if (!words.length) return text

    //   const pattern = new RegExp(
    //     `(${words.map(escapeRegex).join('|')})`,
    //     'gi'
    //   )

    //   return text.replace(
    //     pattern,
    // '<span style="color: orange; font-weight:600;">$1</span>'

    //   )
    // }

    // const renderHighlightedImpressionAsHtml = (text = '', selectedText = []) => {
    //   if (!text) return text

    //   // Filter only valid object highlights with positions
    //   const validHighlights = selectedText.filter(
    //     s => s && typeof s === 'object' && typeof s.start === 'number' && typeof s.end === 'number'
    //   )

    //   if (!validHighlights.length) return text

    //   // Sort by start position
    //   const sorted = [...validHighlights].sort((a, b) => a.start - b.start)

    //   let result = ''
    //   let lastIndex = 0

    //   for (const h of sorted) {
    //     const start = Math.max(h.start, lastIndex)
    //     const end = Math.min(h.end, text.length)
    //     if (start >= end) continue

    //     // Add unhighlighted text before this highlight
    //     result += text.slice(lastIndex, start)
    //     // Add highlighted text
    //     result += `<span style="color: orange;">${text.slice(start, end)}</span>`
    //     lastIndex = end
    //   }

    //   // Add remaining text
    //   result += text.slice(lastIndex)
    //   return result
    // }

    // const renderHighlightedImpressionAsHtml = (
    //   text = '',
    //   selectedText = [],
    //   keywords = []
    // ) => {
    //   if (!text) return ''

    //   // offset highlights (new system)
    //   const offsetHighlights = selectedText.filter(
    //     s => s && typeof s.start === 'number' && typeof s.end === 'number'
    //   )

    //   // keyword highlights (old system)
    //   const keywordHighlights = [
    //     ...keywords,
    //     ...selectedText
    //       .filter(s => s && typeof s === 'object' && s.text)
    //       .map(s => s.text)
    //   ].filter(Boolean)

    //   /* ---------------- OFFSET MODE ---------------- */
    //   if (offsetHighlights.length) {

    //     const sorted = [...offsetHighlights].sort((a, b) => a.start - b.start)

    //     let result = ''
    //     let lastIndex = 0

    //     for (const h of sorted) {

    //       const start = Math.max(h.start, lastIndex)
    //       const end = Math.min(h.end, text.length)

    //       if (start >= end) continue

    //       result += text.slice(lastIndex, start)

    //       // result += `<span style="color: orange; font-weight:600;">${text.slice(start, end)}</span>`
    //       result += `<span class="ql-highlight">${text.slice(start, end)}</span>`

    //       lastIndex = end
    //     }

    //     result += text.slice(lastIndex)

    //     return result
    //   }

    //   /* ---------------- KEYWORD MODE (OLD) ---------------- */

    //   if (keywordHighlights.length) {

    //     const pattern = new RegExp(
    //       `(${keywordHighlights.map(escapeRegex).join('|')})`,
    //       'gi'
    //     )

    //     // return text.replace(
    //     //   pattern,
    //     //   `<span style="color: orange; font-weight:600;">$1</span>`
    //     // )

    //     return text.replace(
    //   pattern,
    //   `<span class="ql-highlight">$1</span>`   // ← class, not style
    // )
    //   }

    //   return text
    // }

    // const renderHighlightedImpressionAsHtml = (
    //   text = '',
    //   selectedText = [],
    //   keywords = []
    // ) => {
    //   if (!text) return ''

    //   // Escape regex special characters
    //   const escapeRegex = (str = '') =>
    //     str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

    //   // Handle string-based highlights (your current format)
    //   const stringHighlights = selectedText.filter(s => typeof s === 'string' && s.trim())

    //   if (stringHighlights.length > 0) {
    //     const pattern = new RegExp(
    //       `(${stringHighlights.map(escapeRegex).join('|')})`,
    //       'gi'
    //     )

    //     return text.replace(
    //       pattern,
    //       '<span class="ql-highlight">$1</span>'
    //     )
    //   }

    //   // Handle offset-based highlights (objects with start/end)
    //   const offsetHighlights = selectedText.filter(
    //     s => s && typeof s === 'object' && typeof s.start === 'number' && typeof s.end === 'number'
    //   )

    //   if (offsetHighlights.length > 0) {
    //     const sorted = [...offsetHighlights].sort((a, b) => a.start - b.start)
    //     let result = ''
    //     let lastIndex = 0

    //     for (const h of sorted) {
    //       const start = Math.max(h.start, lastIndex)
    //       const end = Math.min(h.end, text.length)

    //       if (start >= end) continue

    //       result += text.slice(lastIndex, start)
    //       result += `<span class="ql-highlight">${text.slice(start, end)}</span>`
    //       lastIndex = end
    //     }

    //     result += text.slice(lastIndex)
    //     return result
    //   }

    //   // Handle keyword-based highlights
    //   if (keywords.length > 0) {
    //     const pattern = new RegExp(
    //       `(${keywords.map(escapeRegex).join('|')})`,
    //       'gi'
    //     )

    //     return text.replace(
    //       pattern,
    //       '<span class="ql-highlight">$1</span>'
    //     )
    //   }

    //   return text
    // }

    const highlightedTextStyle = 'font-size: inherit; line-height: inherit; font-weight: 700;'

    const renderHighlightedImpressionAsHtml = (text = '', selectedText = [], keywords = []) => {
      if (!text) return ''

      // Escape regex special characters
      const escapeRegex = (str = '') => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

      // Handle string-based highlights (your current format)
      const stringHighlights = selectedText.filter((s) => typeof s === 'string' && s.trim())

      if (stringHighlights.length > 0) {
        const pattern = new RegExp(`(${stringHighlights.map(escapeRegex).join('|')})`, 'gi')

        // Use inline style instead of class to ensure it works in the RichTextEditor
        return text.replace(pattern, `<span style="${highlightedTextStyle}">$1</span>`)
      }

      // Handle offset-based highlights (objects with start/end)
      const offsetHighlights = selectedText.filter((s) => s && typeof s === 'object' && typeof s.start === 'number' && typeof s.end === 'number')

      if (offsetHighlights.length > 0) {
        const sorted = [...offsetHighlights].sort((a, b) => a.start - b.start)
        let result = ''
        let lastIndex = 0

        for (const h of sorted) {
          const start = Math.max(h.start, lastIndex)
          const end = Math.min(h.end, text.length)

          if (start >= end) continue

          result += text.slice(lastIndex, start)
          // Use inline style instead of class
          result += `<span style="${highlightedTextStyle}">${text.slice(start, end)}</span>`

          lastIndex = end
        }

        result += text.slice(lastIndex)
        return result
      }

      // Handle keyword-based highlights
      if (keywords.length > 0) {
        const pattern = new RegExp(`(${keywords.map(escapeRegex).join('|')})`, 'gi')

        // Use inline style instead of class
        return text.replace(pattern, `<span style="color: orange; ${highlightedTextStyle}">$1</span>`)
      }

      return text
    }

    // const imagingNote =
    //   imaging
    //     ?.filter((imgEntry) =>
    //       noteStructureRef?.current?.metadata?.imagingIds?.includes(
    //         parseInt(imgEntry.id)
    //       )
    //     )
    //     ?.map((obj) => {

    //       const date = obj?.date
    //         ? new Date(obj.date).toLocaleDateString('en-US')
    //         : ''

    //       const name = obj?.data?.name || ''
    //       const impression = obj?.data?.impression || ''

    //       const selectedText = obj?.data?.selectedText || []

    //       const selectedTextStrings = selectedText
    //         .filter(s => s && typeof s === 'object' && s.text)
    //         .map(s => s.text)

    //       // const highlightedImpression = highlightKeywordsHtml(
    //       //   impression,
    //       //   [
    //       //     ...(obj?.filteredKeywords || []),
    //       //     ...selectedTextStrings
    //       //   ]
    //       // )
    //       const highlightedImpression = renderHighlightedImpressionAsHtml(impression, selectedText)

    //       return `
    // <div style="margin-bottom:8px;">
    // <span>${date}${name ? ' - ' + name : ''}</span><br/>
    // ${
    //   impression
    //     ? `<span><strong>Impressions:</strong></span><br/>${highlightedImpression}`
    //     : `<em>No impression available</em>`
    // }
    // </div>
    // `
    //     })
    //     .join('') || ''

    // const imagingNote =
    //   imaging
    //     ?.filter((imgEntry) =>
    //       noteStructureRef?.current?.metadata?.imagingIds?.includes(
    //         parseInt(imgEntry.id)
    //       )
    //     )
    //     ?.map((obj) => {
    //       const date = obj?.date
    //         ? new Date(obj.date).toLocaleDateString('en-US')
    //         : ''

    //       const name = obj?.data?.name || ''
    //       const impression = obj?.data?.impression || ''
    //       const selectedText = obj?.data?.selectedText || []

    //       // Apply highlights directly to the HTML string
    //       const highlightedImpression = renderHighlightedImpressionAsHtml(
    //         impression,
    //         selectedText,
    //         obj?.filteredKeywords || []
    //       )

    //       return `
    // <div style="margin-bottom:8px;">
    // <span>${date}${name ? ' - ' + name : ''}</span><br/>
    // ${
    //   impression
    //     ? `<span><strong>Impressions:</strong></span><br/>${highlightedImpression}`
    //     : `<em>No impression available</em>`
    // }
    // </div>
    // `
    //     })
    //     .join('') || ''

    // Replace your existing imagingNote generation with this:

    const imagingNote =
      imaging
        ?.filter((imgEntry) => noteStructureRef?.current?.metadata?.imagingIds?.includes(parseInt(imgEntry.id)))
        ?.map((obj) => {
          const date = obj?.date ? new Date(obj.date).toLocaleDateString('en-US') : ''

          const name = obj?.data?.name || ''
          const impression = obj?.data?.impression || ''

          // Get selectedText - it's an array of strings in your case
          const selectedText = obj?.data?.selectedText || []

          // Get keywords if available
          const keywords = obj?.data?.keywords || []

          // Apply highlighting to the impression text
          const highlightedImpression = renderHighlightedImpressionAsHtml(impression, selectedText, keywords)

          return `
<div style="margin-bottom:8px;">
  <span>${date}${name ? ' - ' + name : ''}</span><br/>
  ${impression ? `<span><strong>Impressions:</strong></span><br/><div style="white-space: pre-wrap;">${highlightedImpression}</div>` : `<em>No impression available</em>`}
</div>
`
        })
        .join('') || ''

    //till here

    const lastHospitalRecord =
      hospitalRecords
        ?.filter((item) => item.Id === noteStructureRef?.current?.metadata?.historyId)
        ?.map((record) => {
          const history = record?.History || ''

          const highlights = noteStructureRef?.current?.highlightDetails?.[record?.Id] || []

          const highlightedHistory = renderHighlightedImpressionAsHtml(history, highlights)

          return `
<div style="margin-bottom:8px; white-space: pre-wrap;">
${highlightedHistory}
</div>
`
        })
        .join('') || ''

    let allLabsParentHtml = ''

    if (allLabs.length > 0) {
      allLabsParentHtml = allLabs
        .filter((item) => Array.isArray(noteStructureRef.current?.metadata?.labId) ? noteStructureRef.current.metadata.labId.includes(item.id) : item.id === noteStructureRef.current?.metadata?.labId)
        .sort((a, b) => new Date(String(b?.date || '').replace(/\./g, '/')).getTime() - new Date(String(a?.date || '').replace(/\./g, '/')).getTime() || (b?.id || 0) - (a?.id || 0))
        .map((lab) => {
          const date = new Date(lab.date.split('.').join('/')).toLocaleDateString('en-US')

          const labEntries = lab.data
            .map((lab) => {
              const value = lab.value ? parseFloat(lab.value) : null
              const rangeParts = lab.range ? lab.range.split('-').map((part) => parseFloat(part.trim())) : []
              const isValueInRange = value !== null && rangeParts.length === 2 && value >= rangeParts[0] && value <= rangeParts[1]
              return `
<div style="display:flex; ${isValueInRange ? '' : 'font-weight:bold;'}">
<p style="margin: 0;">
${lab.name} ${lab.value} ${lab.unit}
</p>
</div>
`
            })
            .join('')

          return `
  <div style="margin-bottom: 8px;">
<p style="margin: 0;">Date: ${date}</p>
${labEntries}
</div>
`
        })
        .join('')
    }

    const reviewOfSystem = noteStructureRef?.current?.reviewOfSystem || ''

    const poaRowsHTML = (patientDiagnosis || [])
      .filter((diagnosis) => diagnosis && questionValue?.[diagnosis]?.length > 0)
      .map((diagnosis) => {
        const formatted = questionValue?.[diagnosis] || []

        const poaHtmlContent =
          formatted && formatted.length > 0
            ? `
<div  >

<div style="white-space:normal;">
              ${formatted
                .map((item) => {
                    const cleanedRaw = (item?.answer || '').replace(/(background|background-color)\s*:\s*[^;"]+;?/gi, '');
                  const formattedAnswer = cleanedRaw.replace(/([^\n])\s*[•\u2022]\s*/g, '$1\n• ').replace(/<span[^>]*color\s*:\s*(orange|#ffa500)[^>]*>(.*?)<\/span>/gi, '<b>$2</b>')
                  const cleanedFreeType = (item?.freeType || '').replace(/(background|background-color)\s*:\s*[^;"]+;?/gi, '').replace(/([^\n])\s*[•\u2022]\s*/g, '$1\n• ').replace(/<span[^>]*color\s*:\s*(orange|#ffa500)[^>]*>(.*?)<\/span>/gi, '<b>$2</b>');


                  return `
${item?.freewayRemark ? `<div style="margin:0 0 4pt 0; white-space:pre-wrap;">${item.freewayRemark}</div>` : ''}

<p style="margin:0;line-height:20px;">
  <span style="font-weight:bold; text-decoration:${item?.type === 'Header' ? 'underline' : 'none'}; font-size:${item?.type === 'Header' ? '15.5px' : '14px'}">
    ${formatPoaQuestionLabel(item.question, item.type)}
  </span>

  <span style="font-size:13px; white-space: pre-wrap;">${formattedAnswer}</span>
</p>

${
  item.freeType
    ? `<div style="margin:2pt 0 6pt 0;white-space:normal;"><span style="font-weight:bold;font-size:14px;">FreeType</span> - <span style="font-size:13px;white-space:pre-wrap;">${cleanedFreeType}</span></div>`
    : ''
}
`
                })
                .join('')}
</div>

</div>
`
            : ''

        return `
<table style="width: 100%; font-size: 11pt; margin-top: 10pt; border-collapse: collapse; white-space: normal; table-layout: fixed;">
<tr style="vertical-align: top;">
<td style="width: 30%; font-weight: bold; font-size: 13pt; padding: 6px 24px 6px 0; border: 0; line-height: normal; vertical-align: top;"><div style="margin:5pt 0;"><p style="margin:0;">${diagnosis?.toUpperCase()}</p></div></td>
<td style="width: 70%; padding: 6px 0 6px 12px; border: 0; line-height: normal; vertical-align: top;">
${poaHtmlContent}
</td>
</tr>
</table>
<table style="width:100%; border-collapse:collapse; border:none; margin:6px 0;">
<tr style="border:none; height:0; line-height:0;">
<td style="padding:0; border:none; border-bottom:0.5px solid gray; height:0; line-height:0;"></td>
</tr>
</table>
`
      })
      .join('')

    const historyRowsHTML = (patientDiagnosis || [])
      .filter((diagnosis) => diagnosis && noteStructureRef.current.historyOfDiagnosis?.[diagnosis]?.length > 0)
      .map((diagnosis) => {
        const allQuestions = noteStructureRef.current.historyOfDiagnosis?.[diagnosis]
        const historyOfDiagnosis =
          allQuestions && allQuestions.length > 0
            ? `
<div style="margin-bottom:10pt;">
${allQuestions
  .map((q) => {
    const answer = q?.answer ? q.answer?.split('|||') : 'No Answer'
    const freeType = q?.freeType ? ` "${q.freeType}"` : ''
    return `<p style="margin:0;line-height:20px;font-size:10pt;">
<strong>${q?.label}:</strong> ${answer}${freeType}
</p>`
  })
  .join('')}
</div>
`
            : ''

        return `
<table style="width: 100%; font-size: 11pt; margin-top: 10pt; border-collapse: collapse; white-space: normal; table-layout: fixed;">
<tr style="vertical-align: top;">
<td style="width: 30%; font-weight: bold; font-size: 13pt; padding: 6px 24px 6px 0; border: 0; line-height: normal; vertical-align: top;"><div style="margin:5pt 0;"><p style="margin:0;">${diagnosis?.toUpperCase()}</p></div></td>
<td style="width: 70%; padding: 6px 0 6px 12px; border: 0; line-height: normal; vertical-align: top;">
${historyOfDiagnosis}
</td>
</tr>
</table>
<table style="width:100%; border-collapse:collapse; border:none; margin:6px 0;">
<tr style="border:none; height:0; line-height:0;">
<td style="padding:0; border:none; border-bottom:0.5px solid gray; height:0; line-height:0;"></td>
</tr>
</table>
`
      })
      .join('')

    const treatmentShellHTML = (patientDiagnosis || [])

      ?.filter(Boolean)
      ?.map((diagnosis, i) => {
        const riskFactor =
          selectedRisks && selectedRisks[diagnosis]
            ? selectedRisks[diagnosis]
                .split(',')
                .map((risk) => risk.trim())
                .filter(Boolean)
                .join(', ')
            : ''



        // const riskFactorFreeType= noteStructureRef.current.riskFactorFreeType
        //risk factor were not rendering
        const riskFactorFreeType = noteStructureRef.current.freeTypesEverything?.riskfactors?.[diagnosis] || ''

        const renderRiskFactorNotePreview = noteStructureRef.current?.riskFactors?.[diagnosis] || ''





//         const riskFactorHtmlContent = original
//           riskFactor &&
//           `
// <div style="margin-bottom:5pt;margin-top:5pt">
// <p style="margin:0;font-weight:700;line-height:22px;font-size:11pt;">${'Risk Fssactor'}</p>
//       <div class="">${riskFactor}</div>
//           <div class="">${riskFactorFreeType}</div>
// </div>`


  //   ${riskFactor ? `<div>${riskFactor}</div>` : ''}these two can be used below to render the risk factor free type 
  // ${riskFactorFreeType ? `<div>${riskFactorFreeType}</div>` : ''}


// const riskFactorHtmlContent =
//   (riskFactor || riskFactorFreeType || renderRiskFactorNotePreview) &&

//   //   <p style="margin:0;font-weight:700;line-height:22px;font-size:11pt;">Risk Factor</p>
//   // ${riskFactor ? `<div>${riskFactor}</div>` : ''}
//   `
// <div style="margin-bottom:5pt;margin-top:5pt">

//   <p style="margin:0;font-weight:700;line-height:22px;font-size:11pt;">Risk Factors</p>


//     ${riskFactorFreeType ? `<div style="font-style:italic; margin-top:4px;">${riskFactorFreeType}</div>` : ''}

//       ${renderRiskFactorNotePreview ? `<div style="font-style:italic; margin-top:4px;">${renderRiskFactorNotePreview}</div>` : ''}


// </div>
// `
const riskFactorHtmlContent =
  (riskFactorFreeType || renderRiskFactorNotePreview || riskFactor) &&
  `
<div style="margin-bottom:5pt;margin-top:5pt">
  <p style="margin:0;font-weight:700;line-height:22px;font-size:11pt;">Risk Factors</p>

  ${
    riskFactorFreeType
      ? `<div style=" margin-top:4px;">${riskFactorFreeType}</div>`
      : renderRiskFactorNotePreview
      ? `<div style=" margin-top:4px;">${renderRiskFactorNotePreview}</div>`
      : `<div style="margin-top:4px;">${riskFactor}</div>`
  }

</div>
`


        const differentialDiagnosisHTML = ddxHtml[diagnosis]
          ? `
<div style="margin-bottom:10pt;">
<p style="margin:0;font-weight:700;line-height:22px;font-size:11pt;">${'Differential Diagnosis'}</p>
<p style="margin-top:0;">          ${ddxHtml[diagnosis].replace(/\n/g, '<br />')}</p>
</div>
`
          : ''

        //         const morseCodeHtml =
        //             diagnosis === 'Falls' &&
        //                 noteStructureRef?.current?.MorseScore
        //                 ? (() => {
        //                     const { date, score } = noteStructureRef.current.MorseScore[diagnosis];
        //                     const totalScore = score && score[score.length - 1]; // Last index is the total score

        //                     return `
        // <div style="margin-bottom:10pt;">
        //         <p style="margin:0;font-weight:700;line-height:22px;font-size:11pt;">${"Morse Score"}</p>
        //             <p style="margin-top:0;"><span>Score :</span> ${totalScore} <span style=";">Date :</span> ${formatDate(date)}</p>
        // </div>
        // `;
        //                 })()
        //                 : '';

        const morseCodeHtml =
          diagnosis === 'Falls' && noteStructureRef?.current?.MorseScore?.[diagnosis]
            ? (() => {
                const entry = noteStructureRef.current.MorseScore[diagnosis]
                const { date, score } = entry || {}
                const totalScore = Array.isArray(score) ? score[score.length - 1] : 'N/A'

                return `
<div style="margin-bottom:10pt;">
<p style="margin:0;font-weight:700;line-height:22px;font-size:11pt;">${'Morse Score'}</p>
<p style="margin-top:0;">
<span>Score :</span> ${totalScore} 
<span style="">Date :</span> ${date ? formatDate(date) : 'Unknown'}
</p>
</div>
`
              })()
            : ''

        const ddxValues = (noteStructureRef?.current && noteStructureRef?.current?.patientDifferentialDiagnosis && noteStructureRef?.current?.patientDifferentialDiagnosis[diagnosis] && noteStructureRef?.current?.patientDifferentialDiagnosis[diagnosis]) || ''
        let ddxHtmlsTreatMents = ''
        if (ddxValues && ddxValues.length > 0) {
          const ddxFormatted = ddxValues.replace(/\n/g, '<br />')

          ddxHtmlsTreatMents = ddxFormatted
            ? `
<div style="margin-bottom:5pt;margin-top:5pt">
<p style="margin:0;font-weight:700;line-height:22px;font-size:11pt;">Differential Diagnosis</p>
<p style="margin-top:0;">${ddxFormatted}</p>
</div>
`
            : ''
        }

        const alertValue = (noteStructureRef?.current && noteStructureRef?.current?.alertData && noteStructureRef?.current?.alertData[diagnosis] && noteStructureRef?.current?.alertData[diagnosis]) || ''
        let alertHtml = ''
        if (alertValue && alertValue.length > 0) {
          alertHtml = alertValue
            ? `
<div style="margin-bottom:5pt;margin-top:5pt">
<p style="margin:0;font-weight:700;line-height:22px;font-size:11pt;">${'Alerts'}</p>
    <div style="white-space: pre-wrap;margin-top:0;">${alertValue}</div>
</div>`
            : ''
        }
        const bimsScoreData = noteStructureRef?.current?.BIMSScore?.[diagnosis]
        const bimsScoreHtml =
          diagnosis === 'Cognitive Communication Deficit' && bimsScoreData
            ? (() => {
                const { date, score } = bimsScoreData

                return `
<div style="margin-bottom:5pt;margin-top:5pt">
<p style="margin:0;font-weight:700;line-height:22px;font-size:11pt;">${'BIMS Score'}</p>
  <p style="margin-top:0;">Score : ${score || 0} <span style="margin-left:20px;">Date :</span> ${formatDate(date) || ''}</p>
</div>
                `
              })()
            : ''

        const sortedLabs = allLabs.slice().sort((a, b) => new Date(String(b?.date || '').replace(/\./g, '/')).getTime() - new Date(String(a?.date || '').replace(/\./g, '/')).getTime() || (b?.id || 0) - (a?.id || 0))
        const lastLab = sortedLabs[0]
        const lastLabArrOfLabs = lastLab?.data || []
        const allMatchingLab =
          lastLabArrOfLabs &&
          lastLabArrOfLabs.filter((item) => {
            const diagnosisLab = item.diagnosis.split(',').filter((item) => item !== '')
            return diagnosisLab.some((diagn) => diagn.includes(diagnosis))
          })
        const matchingLabHtml = allMatchingLab.length
          ? `
<div style="margin-bottom:5pt;margin-top:5pt">
<p style="font-size:14px; font-weight:bold;">Lab Details</p>

<div>
${allMatchingLab
  .map((item) => {
    return `
<div style="display: flex; gap: 10px; font-size: 13px;">
<p style="line-height:2;">${new Date(lastLab?.date).toLocaleDateString('en-US')} ${item.name} ${item.value || '-'} ${item.unit || '-'} ${item?.comment || ''}</p>
</div>
`
  })
  .join('')}
</div>
</div>
`
          : ''

        let matchingImagingDiagnosis = null

        const lastImaging = imaging?.length > 0 ? imaging[imaging.length - 1] : null

        if (imagingTypeList.length > 0 && lastImaging?.data && MasterDiagnosisData) {
          try {
            const lastImagingImpression = lastImaging.data.impression.toLowerCase()
            const lastImagingName = lastImaging.data.name.toLowerCase()

            const matchingImagingMaster = imagingTypeList.find((item) => item.Name.toLowerCase() === lastImagingName)

            if (matchingImagingMaster) {
              const matchedKeywords = matchingImagingMaster.Keywords.filter((keywordDetail) => {
                const keywords = keywordDetail.keyword
                  .split(',')
                  .map((k) => k.trim().toLowerCase())
                  .filter(Boolean)
                return keywords.some((k) => lastImagingImpression.includes(k))
              })

              for (const remark of matchedKeywords) {
                const matchedDiagnosis = MasterDiagnosisData.find((d) => d.id === Number(remark.diagnosis))
                if (matchedDiagnosis && diagnosis.trim() === matchedDiagnosis.Name.trim()) {
                  matchingImagingDiagnosis = {
                    ...matchedDiagnosis,
                    ...remark,
                    ...lastImaging,
                  }
                  break
                }
              }
            }
          } catch (error) {
            console.log('error data ', error)
          }
        }

        const imagingHTML = matchingImagingDiagnosis?.data
          ? `
<div style="padding: ;">
<h7>Imagings</h7>
<p class="text-warning">
${new Date(matchingImagingDiagnosis.date).toLocaleDateString('en-US')} : 
${matchingImagingDiagnosis.data.name}
</p>
<p class="text-warning">${matchingImagingDiagnosis.data.impression}</p>
<p class="text-warning">${matchingImagingDiagnosis.data.comment}</p>
</div>
`
          : ''

        let freeType = ''
        let poa = ''
        let assessment = ''
        let newAssessment = ''
        let assessmentSuggestions = ''
        let selfCareAssessment = ''
        if (patientTreatments && patientTreatments.length > 0) {
          let treatmentDetails = patientTreatments[noteID || 0]

          if (!treatmentDetails) {
            treatmentDetails = patientTreatments[0]
          }
          const { data } = treatmentDetails
          if (!data?.assessment) {
            // noteStructureRef.current = {
            //   ...noteStructureRef.current,
            //   assessment: {
            //     ...noteStructureRef.current.assessment,
            //     [diagnosis]: {
            //       MobilityAssessment: {},
            //       POA: '',
            //       MorseScore: {},
            //       LabImaging: '',
            //       FreeType: '',
            //     },
            //   },
            // }
          } else if (data?.assessment && !data?.assessment[diagnosis]) {
            // noteStructureRef.current = {
            //   ...noteStructureRef.current,
            //   assessment: {
            //     ...noteStructureRef.current.assessment,
            //     [diagnosis]: {
            //       MobilityAssessment: {},
            //       POA: '',
            //       MorseScore: {},
            //       LabImaging: '',
            //       FreeType: '',
            //     },
            //   },
            // }
          } else if (data?.assessment && data?.assessment[diagnosis]) {
            if (typeof data.assessment[diagnosis] === 'string') {
              // noteStructureRef.current = {
              //   ...noteStructureRef.current,
              //   assessment: {
              //     ...noteStructureRef.current.assessment,
              //     [diagnosis]: {
              //       MobilityAssessment: {},
              //       POA: '',
              //       MorseScore: {},
              //       LabImaging: '',
              //       FreeType: '',
              //     },
              //   },
              // }
            }
          }
          let existingAssessment = `${noteStructureRef?.current?.assessment && noteStructureRef?.current?.assessment[diagnosis]?.LabImaging} ` || ''
          // const existingAssessment = (noteStructureRef?.current?.assessment && noteStructureRef?.current?.assessment[diagnosis]) || "";
          if (existingAssessment.trim() === 'undefined' || existingAssessment === 'null') {
            existingAssessment = ''
          }
          let freeTypeData = (noteStructureRef?.current?.assessment && noteStructureRef?.current?.assessment[diagnosis]?.FreeType) || ''
          // if (diagnosis !== 'Falls') {
          //     existingAssessment = (noteStructureRef?.current?.assessment && noteStructureRef?.current?.assessment[diagnosis]) || "";
          // } else {
          //     existingAssessment = (noteStructureRef?.current?.assessment && noteStructureRef?.current?.assessment[diagnosis]?.LabImaging) || "";
          // }
          // setFreeType(freeTypeData);
          freeType = freeTypeData
          newAssessment = existingAssessment || ''
        } else {
          // noteStructureRef.current = {
          //   ...noteStructureRef.current,
          //   assessment: {
          //     ...noteStructureRef.current.assessment,
          //     [diagnosis]: {
          //       MobilityAssessment: {},
          //       POA: '',
          //       MorseScore: {},
          //       LabImaging: '',
          //       FreeType: '',
          //     },
          //   },
          // }
        }

        let allImagingRemarks = null
        let lastLabsRemarks = []
        let standingMedicationTemplate = ''
        if (imagingTypeList.length > 0 && lastImaging?.data) {
          try {
            const lastImagingImpression = lastImaging.data.impression.toLowerCase()
            const lastImagingPatientSelectedImaging = lastImaging.data.name.toLowerCase()
            const findMatchingImagingMaster = imagingTypeList.find((item) => item.Name.toLowerCase() === lastImagingPatientSelectedImaging)
            if (findMatchingImagingMaster) {
              let matchingDiagnosisImaging = []
              for (let keywordDetail of findMatchingImagingMaster.Keywords) {
                const keywordsArray = keywordDetail.keyword
                  .split(',')
                  .map((keyword) => keyword.trim().toLowerCase())
                  .filter((keyword) => keyword !== '')
                if (keywordsArray.some((item) => lastImagingImpression.includes(item?.toLowerCase()))) {
                  matchingDiagnosisImaging.push(keywordDetail)
                }
              }
              for (const remarkD of matchingDiagnosisImaging) {
                for (const masterD of MasterDiagnosisData) {
                  if (masterD.id === Number(remarkD.diagnosis)) {
                    if (diagnosis.trim() === masterD.Name.trim()) {
                      allImagingRemarks = [
                        {
                          ...masterD,
                          ...remarkD,
                          ...lastImaging,
                        },
                      ]
                    }
                  }
                }
              }
            }
          } catch (error) {
            console.error('error', error)
          }
        }
        if (allLabs.length > 0) {
          const lastLab = allLabs.slice().sort((a, b) => new Date(String(b?.date || '').replace(/\./g, '/')).getTime() - new Date(String(a?.date || '').replace(/\./g, '/')).getTime() || (b?.id || 0) - (a?.id || 0))[0]
          const lastLabArrOfLabs = lastLab?.data || []
          let allMatchingLab = lastLabArrOfLabs.filter((item) => {
            const diagnosisLab = item.diagnosis.split(',').filter((item) => item !== '')
            return diagnosisLab.some((diagn) => diagn.includes(diagnosis))
          })
          lastLabsRemarks = allMatchingLab.map((item) => item.remark).filter((item) => item !== '')
        }
        if (lastLabsRemarks.length > 0) {
          const lastLabsRemarksText = lastLabsRemarks.join('\n')
          if (!newAssessment.includes(lastLabsRemarksText)) {
            if (newAssessment !== '') {
              // newAssessment += '\n';
            }
            newAssessment += lastLabsRemarksText
          }
        }
        if (allImagingRemarks) {
          if (!newAssessment.includes(allImagingRemarks[allImagingRemarks.length - 1]?.remarks)) {
            if (newAssessment !== '') {
              // newAssessment += '\n';
            }
            newAssessment += allImagingRemarks[allImagingRemarks.length - 1]?.remarks //tunr this off letter
          }
          // newAssessment += allImagingRemarks?.remarks; // turn this on
        }

        if (newAssessment.trim() !== '' && newAssessment.trim() !== 'undefined' && newAssessment !== 'null') {
          // setAssessment(newAssessment);
          assessment = newAssessment
          // const currentAssessment = noteStructureRef.current.assessment || {}
          // const existingDiagnosisData = currentAssessment[diagnosis] || {
          //   MobilityAssessment: {},
          //   POA: '',
          //   MorseScore: {},
          //   LabImaging: '',
          //   FreeType: '',
          // }
        }

        // const morseCodeHtmlInAssessment =
        //     diagnosis === 'Falls' &&
        //         noteStructureRef?.current?.MorseScore
        //         ? (() => {
        //             const { date, score } = noteStructureRef.current.MorseScore[diagnosis];
        //             const totalScore = score && score[score.length - 1]; // Last index is the total score

        //             return `<div>Morse Score: ${totalScore} Date: ${new Date(date).toLocaleDateString('en-US')}</div>`;
        //         })()
        //         : '';

        const morseCodeHtmlInAssessment =
          diagnosis === 'Falls' && noteStructureRef?.current?.MorseScore?.[diagnosis]
            ? (() => {
                const entry = noteStructureRef.current.MorseScore[diagnosis]
                const { date, score } = entry || {}
                const totalScore = Array.isArray(score) ? score[score.length - 1] : 'N/A'
                const formattedDate = date ? new Date(date).toLocaleDateString('en-US') : 'Unknown'

                return `<div>Morse Score: ${totalScore} Date: ${formattedDate}</div>`
              })()
            : ''

        //mobilityHtmlInAssessment in falls
        const questionFields = [
          { key: 'rollLeftAndRight', label: 'Roll left and right' },
          { key: 'sitToLying', label: 'Sit to lying' },
          { key: 'lyingToSittingOnSideOfBed', label: 'Lying to sitting on side of bed' },
          { key: 'sitToStand', label: 'Sit to stand' },
          { key: 'chairToBedTransfer', label: 'Chair to bed transfer' },
          { key: 'toiletTransfer', label: 'Toilet transfer' },
          { key: 'walk10Feet', label: 'Walk 10 feet' },
          { key: 'ambulatoryAids', label: 'Ambulatory aids' },
        ]

        const commonOptions = [
          { label: 'Independent', value: 'independent' },
          { label: 'Set up or cleanup assistance', value: 'setup_or_cleanup_assistance' },
          { label: 'Supervision or touching assistant', value: 'supervision_or_touching_assistant' },
          { label: 'Partial moderate assistant', value: 'partial_moderate_assistant' },
          { label: 'Substantial maximal assistant', value: 'substantial_maximal_assistant' },
          { label: 'Dependent', value: 'dependent' },
          { label: 'Patient refused', value: 'patient_refused' },
        ]

        const ambulatoryOptions = [
          { label: 'None', value: 'none' },
          { label: 'Wheelchair', value: 'wheelchair' },
          { label: 'Cane', value: 'cane' },
          { label: 'Walker', value: 'walker' },
        ]

        const mobilityValuesInAssessment = noteStructureRef?.current?.MobilityAssessment?.assessment
        assessmentSuggestions = noteStructureRef?.current?.assessment?.[diagnosis]?.assessmentSuggestions
        const date = noteStructureRef?.current?.MobilityAssessment?.date
        const formattedDate = date ? new Date(date).toLocaleDateString('en-US') : 'Unknown'

        const mobilityHtmlInAssessment =
          diagnosis === 'Falls' && mobilityValuesInAssessment
            ? (() => {
                return ` 
                <div>Date: ${formattedDate}</div>
                <div>
                  ${questionFields
                    .map((field) => {
                      const selected = mobilityValuesInAssessment[field.key]
                      if (selected && selected.length > 0) {
                        const values = selected.map((item) => (item?.label ? item.label : JSON.stringify(item))).join(', ')
                        return `<div class="" style="">${field.label}: ${values}</div>`
                      }
                      return ''
                    })
                    .join('')}
            </div>`
              })()
            : ''

        let incidentHtmlContent = ``

        if (noteStructureRef?.current?.incident) {
          const allKeys = Object.keys(noteStructureRef?.current?.incident)
          const filteredKeys = allKeys.filter((key) => key.startsWith(diagnosis))

          const allIncidentsWithDates = filteredKeys.map((key) => {
            const date = key.split(`${diagnosis}_`)[1]
            return {
              date: date,
              incidents: noteStructureRef?.current?.incident[key],
            }
          })

          if (allIncidentsWithDates.length > 0) {
            incidentHtmlContent = allIncidentsWithDates
              .map((incident) => {
                const itemsHtml =
                  incident?.incidents && incident?.incidents.length > 0
                    ? incident?.incidents
                        .filter((item) => item.answer)
                        .map(
                          (item, idx) =>
                            `<div>
        <p class="p-0 m-0">${idx + 1}. ${item.label}</p>
        <p class="p-0 m-0" style="white-space: pre-wrap;">Answer: ${item.answer}</p>
    ${item?.freeType ? `<div style="white-space: pre-wrap;">Freetype:  ${item?.freeType}</div>` : ''}

                            </div>`,
                        )
                        .join('')
                    : ''

                return `
    <div>
      <p style="margin:0;padding:0pt;padding:6pt 0pt">${new Date(incident?.date).toLocaleDateString('en-US')}</p>
                ${incident?.incidents[0]?.freeRemark ? `<p style="white-space: pre-wrap;">${incident?.incidents[0]?.freeRemark ? incident?.incidents[0]?.freeRemark : ''}</p> ` : ''}

      ${itemsHtml}
                    </div>
                `
              })
              .join('')
          }
        }
         let selfCareHtmlContent = null
         const diagnosisData = noteStructureRef?.current?.selfCareAssessment?.[diagnosis] || {}


         console.log("diagnosisDatadiagnosisData", diagnosisData)


      //   const formattedSelfCareAssessment = Object.entries(diagnosisData)
      //     .map(([domain, value]) => {
      //       if (Array.isArray(value) && value.length > 0) {
      //         return value
      //           .map(
      //             (item) => `
      //     <div style="margin:0;line-height:16px;">
      //       <p style="text-transform: capitalize;">${domain}:${item}</p> 
      //     </div>
      //   `,
      //           )
      //           .join('')
      //       }

      //       if (typeof value === 'string' && value.trim()) {
      //         return `
      //   <div style="margin:0;line-height:16px;">
      //     <p style="text-transform: capitalize;">${domain}: ${value}</p>
      //   </div>
      // `
      //       }
      //       return ''
      //     })
      //     .filter(Boolean)
      //     .join('')




       const isEmpty = (val) => {
  if (val === null || val === undefined) return true
  if (typeof val === 'string') return val.trim() === ''
  if (Array.isArray(val)) return val.length === 0
  if (typeof val === 'object') {
    return Object.values(val).every(v => isEmpty(v))
  }
  return false
}

const formatValue = (domain, value, isSub = false) => {
  const formattedDomain = domain === 'date' ? 'Date' : domain

  // ❌ Skip empty values
  if (isEmpty(value)) return ''

  // Array
  // if (Array.isArray(value)) {
  //   return value.map(item => `
  //     <div style="margin-left:${isSub ? '10px' : '0'};">
  //       ${formattedDomain}: ${item}
  //     </div>
  //   `).join('')
  // }

  if (Array.isArray(value)) {
  const filtered = value.filter(v => v && v.toString().trim())
  if (filtered.length === 0) return ''

  return `
    <div style="margin-left:${isSub ? '10px' : '0'};">
     <span> ${formattedDomain} </span> : ${filtered.join(', ')}
    </div>
  `
}

  // String
  if (typeof value === 'string') {
    return `
      <div style="margin-left:${isSub ? '10px' : '0'};">
        ${formattedDomain}: ${value}
      </div>
    `
  }

  // Object (ONLY render if it has valid children)
  if (typeof value === 'object') {
    const children = Object.entries(value)
      .map(([subKey, subValue]) => formatValue(subKey, subValue, true))
      .filter(Boolean) // ✅ remove empty results

    if (children.length === 0) return '' // 🚀 KEY FIX

    return `
      <div style="margin-top:8px;">
        <div style="font-weight:700; margin-bottom:4px;">
          ${formattedDomain}
        </div>
        ${children.join('')}
      </div>
    `
  }

  return ''
}



//           const formatValue = (domain, value, isSub = false) => {
//   const formattedDomain = domain === 'date' ? 'Date' : domain;
 
//   // Array
//   if (Array.isArray(value) && value.length > 0) {
//     return value.map(item => `
//       <div style="margin-left:${isSub ? '10px' : '0'};">
//         ${formattedDomain}: ${item}
//       </div>
//     `).join('');
//   }
 
//   // String
//   if (typeof value === 'string' && value.trim()) {
//     return `
//       <div style="margin-left:${isSub ? '10px' : '0'};">
//         ${formattedDomain}: ${value}
//       </div>
//     `;
//   }
 
//   // ✅ Only THIS should be bold (section headings)
//   if (typeof value === 'object' && value !== null) {
//     return `
//       <div style="margin-top:8px;">
//         <div style="font-weight:700; margin-bottom:4px;">
//           ${formattedDomain}
//         </div>
//         ${Object.entries(value)
//           .map(([subKey, subValue]) => formatValue(subKey, subValue, true))
//           .join('')}
//       </div>
//     `;
//   }
 
//   return '';
// };
 
 
 
        
 
 
  const formattedSelfCareAssessment = Object.entries(diagnosisData)
  .map(([domain, value]) => formatValue(domain, value))
  .join('');
 
 



const selfCareAssessmentSuggestion = 
  noteStructureRef?.current?.freeTypesEverything?.assessments?.[diagnosis]?.assessmentSuggestions || ''
          
        const selfCareAssessmentFormat = formattedSelfCareAssessment || ''
        selfCareHtmlContent = selfCareAssessmentFormat
          ? `
              <div>             
                  ${selfCareAssessmentFormat}
                </div>
              </div>
            `
          : ''


//         const assessmentHtmlContent =
//           poa.trim() || assessment.trim() || freeType.trim() || morseCodeHtmlInAssessment.trim() || mobilityHtmlInAssessment.trim() || bimsScoreData
//             ? `
// <div style="margin-bottom:5pt;margin-top:5pt">
// <p style="margin:0;font-weight:700;line-height:22px;font-size:11pt;">${'ASSESSMENT'}</p>
// <div>
// <div style="">
// ${poa ? `<div>${poa}</div>` : ''}
// ${mobilityHtmlInAssessment}
//  ${morseCodeHtmlInAssessment}
// ${assessmentSuggestions ? `<div style="white-space: pre-line;">${assessmentSuggestions}</div>` : ''}           
// ${freeType ? `<div>${freeType}</div>` : ''}
// ${assessment ? `<div>${assessment}</div>` : ''}
// ${bimsScoreData ? `<div>Bims Score: ${bimsScoreData?.score} Date: ${new Date(bimsScoreData?.date).toLocaleDateString('en-US')}</div>` : ''}
// </div>
// </div>
// </div>
// `
//             : ''
const assessmentHtmlContent =
  poa?.trim() ||
  assessment?.trim() ||
  freeType?.trim() ||
  morseCodeHtmlInAssessment?.trim() ||
  mobilityHtmlInAssessment?.trim() ||
  assessmentSuggestions?.trim() ||
  bimsScoreData || selfCareAssessmentFormat?.trim()
    ? `
<div style="margin-bottom:5pt;margin-top:5pt">
  <p style="margin:0;font-weight:700;line-height:22px;font-size:11pt;">ASSESSMENT</p>

  <ul style="${topLevelBulletListStyle}">
    
    ${toBulletItems(poa, topLevelBulletItemStyle)}
    ${toBulletItems(assessment, topLevelBulletItemStyle)}

    ${mobilityHtmlInAssessment ? `<li style="${topLevelBulletItemStyle}"><div style="${nestedBulletContentStyle}">${mobilityHtmlInAssessment}</div></li>` : ''}
    ${selfCareAssessmentFormat ? `<li style="${topLevelBulletItemStyle}"><div style="${nestedBulletContentStyle}">${selfCareAssessmentFormat}</div></li>` : ''}

    ${morseCodeHtmlInAssessment ? `<li style="${topLevelBulletItemStyle}"><div style="${nestedBulletContentStyle}">${morseCodeHtmlInAssessment}</div></li>` : ''}
    ${
      bimsScoreData
        ? `<li style="${topLevelBulletItemStyle}">Bims Score: ${bimsScoreData?.score} Date: ${new Date(
            bimsScoreData?.date
          ).toLocaleDateString('en-US')}</li>`
        : ''
    }

    ${assessmentSuggestions
      ? `<li style="list-style:none;margin:0;padding:0;">
          ${renderAssessmentSuggestionHtml(assessmentSuggestions)}
        </li>`
      : ''}

   ${toBulletItemsFromBulletText(freeType, topLevelBulletItemStyle)}



  </ul>
</div>
`
    : ''

        let allData = []
        let planFormat = ''
        let lab = ''
        let misc = ''
        let planHtmlContent = null
        // let selfCareHtmlContent = null

        if (patientTreatments && patientTreatments.length > 0) {
          let treatmentDetails = patientTreatments[noteID || 0]

          if (!treatmentDetails) {
            treatmentDetails = patientTreatments[0]
          }

          const { data } = treatmentDetails
          // noteStructureRef.current = data   /// if something is not work plan then uncomment it, may be work

          let miscData = data && data.plans && noteStructureRef?.current?.plans[diagnosis]?.labRemark + noteStructureRef?.current?.plans[diagnosis]?.misc

          lab = noteStructureRef?.current?.plans && noteStructureRef?.current?.plans[diagnosis] && noteStructureRef?.current?.plans[diagnosis]?.labRemark
          misc = noteStructureRef?.current?.plans && noteStructureRef?.current?.plans[diagnosis] && noteStructureRef?.current?.plans[diagnosis]?.freeType
          let planSuggestions = noteStructureRef?.current?.plans && noteStructureRef?.current?.plans[diagnosis] && noteStructureRef?.current?.plans[diagnosis]?.planSuggestion
          let freetype = noteStructureRef?.current?.plans && noteStructureRef?.current?.plans[diagnosis] && noteStructureRef?.current?.plans[diagnosis]?.freeType
          let labRemark = noteStructureRef?.current?.plans && noteStructureRef?.current?.plans[diagnosis] && noteStructureRef?.current?.plans[diagnosis]?.labRemark
          let ordersList = orders[diagnosis] || []
          allData = noteStructureRef?.current?.plans && noteStructureRef?.current?.plans[diagnosis] && noteStructureRef?.current?.plans[diagnosis]?.medsDetails
          const formattedMedicationDetailsInFormattedRed =
            allData &&
            allData.length > 0 &&
            allData
              ?.map((item) => {
                // return `${item?.name} - <span>${item?.dosage}</span> - <span class="med-frequency" >${item?.frequency}</span> <br/> <span class="standing-template">${item?.standingTemplateName}</span></span>`;
                // return ` <span style="">${item?.editedMed}</span> <br/> <span class="standing-template" style="">${item?.extraStandings}</span> <br/> <span class="standing-template" style="">${item?.sideEffect}</span> <br/> <span class="standing-template" style="">${item?.mechanismOfAction}</span> <br/> <span class="standing-template" style="">${item?.alerts}</span> <br/> <span class="standing-template" style="">${item?.therapeuticLevels?.min} - ${item?.therapeuticLevels?.max}</span>`;
                return `<span style="">${item?.editedMed}</span>  
`
              })
              .join('<br/>')

          let orderHtmlPlan = ''

          if (orders && orders[diagnosis]?.length > 0) {
            let orderContentHtml = ''

            orders[diagnosis].forEach((currentOrder) => {
              if (currentOrder?.noteID !== noteID) {
                return
              }
              let currentOrderHtml = `<div class="">`

              // Imaging – inline with spacing between each item
              if (currentOrder?.imaging?.imagingTypes?.length > 0) {
                currentOrderHtml += `
<div style="display:flex;flex-wrap:wrap;gap:4pt;margin:0;padding:0;width:100%;">
<span style="margin:0;margin-top:0pt;padding:0;white-space:nowrap;">Imaging : </span>
${currentOrder.imaging.imagingTypes
  .map((imagingItem) => {
    const type = typeof imagingItem?.type === 'object' ? JSON.stringify(imagingItem?.type) : imagingItem?.type || ''
     const reason = typeof imagingItem?.reason  === 'object' ? JSON.stringify(imagingItem?.reason) : imagingItem?.reason || ''
      const code = typeof imagingItem?.code === 'object' ? JSON.stringify(imagingItem?.code) : imagingItem?.code || ''
    return `<span style="margin:0;padding:0;white-space:nowrap;">${type},${reason},${code}</span>`
  })
  .join('')}
</div>
`
              }

              // Labs
              if (currentOrder?.lab?.labs?.length > 0) {
                currentOrderHtml += `
<div style="display:flex;flex-wrap:wrap;gap:4pt;margin:0;padding:0;width:100%;">

${currentOrder.lab.labs
  .map((labItem) => {
    const lab = typeof labItem?.lab === 'object' ? JSON.stringify(labItem?.lab) : labItem?.lab || ''
    const reason = typeof labItem?.reason === 'object' ? JSON.stringify(labItem?.reason) : labItem?.reason || ''
     const code = typeof labItem?.code === 'object' ? JSON.stringify(labItem?.code) : labItem?.code || ''
    return `<span style="margin:0;padding:0;white-space:nowrap;">${lab}${reason ? ` - Reason for ${lab}` :''}${code ? ` - Code for ${lab}` : ''},</span>`
  })
  .join('')}

</div>
`
              }

              // Medications
              if (currentOrder?.medication?.medication?.length > 0) {
                currentOrderHtml += `
<div style="display:flex;flex-wrap:wrap;gap:4pt;margin:0;padding:0;width:100%;">
<span style="margin:0;padding:0;white-space:nowrap;">Medications: </span>
${currentOrder.medication.medication
  .map((medItem) => {
    return `<span style="margin:0;padding:0;white-space:nowrap;">${medItem?.name} ${medItem?.dosage} ${medItem?.route}${medItem?.frequency ? ` ${medItem?.frequency}` : ''}${medItem?.reason ? ` - ${medItem?.reason}` : ''}${medItem?.code ? ` - ${medItem?.code}` : ''},</span>`
  })
  .join('')}
</div>
`
              }

              // // Miscellaneous
              currentOrderHtml += `
<div style="margin:0;padding:0;">
  
  <span style="margin:0;padding:0;">
    ${(currentOrder?.miscellaneous?.miscellaneous || []).map((misc) => `<span style="margin:0;padding:0;">Miscellaneous: ${misc.type}</span>`).join('')}
  </span>
</div>
`

              currentOrderHtml += `</div>` // close order block
              if (hasRealContent(currentOrderHtml)) {
                orderContentHtml += currentOrderHtml
              }
            })

            if (hasRealContent(orderContentHtml)) {
              orderHtmlPlan = `<label style="margin:0;padding:0;line-height:normal;" class="form-label">New Orders</label><div>${orderContentHtml}</div>`
            }
          }

          // ${planFormat ? `<div style="">${planFormat}</div>` : ""}
 
          const planFormat = formattedMedicationDetailsInFormattedRed || ''
          planHtmlContent =
            planFormat ||
              orderHtmlPlan ||
              planSuggestions ||
              allTreamentStatements[diagnosis] ||
              freetype ||
              labRemark
              ? `
<div style="margin-bottom:5pt;margin-top:5pt;">
  <p style="margin:0;font-weight:700;line-height:22px;font-size:11pt;">PLAN</p>

  <ul style="${topLevelBulletListStyle}">
     ${toBulletItemsFromBulletText(freetype, topLevelBulletItemStyle)}
    ${planSuggestions
      ? `<li style="list-style:none;margin:0;padding:0;">
          ${renderPlanSuggestionContent(planSuggestions)}
        </li>`
      : ''}
    ${toBulletItems(labRemark, topLevelBulletItemStyle)}
    ${renderNestedBulletContent(orderHtmlPlan)}
    ${renderNestedBulletContent(planFormat)}
    ${toBulletItems(allTreamentStatements[diagnosis], topLevelBulletItemStyle)}
  </ul>
</div>
`
              : ''

//           planHtmlContent =
//             planFormat || orderHtmlPlan || planSuggestions || allTreamentStatements[diagnosis] || freetype || labRemark
//               ? `
// <div style="margin-bottom:5pt;margin-top:5pt;">
//   <p style="margin:0;font-weight:700;line-height:22px;font-size:11pt;">${'PLAN'}</p>
// ${freetype ? `<div style="white-space: pre-line;margin-top:0;">${freetype}</div>` : ''}
// ${planSuggestions ? `<div style="white-space: pre-line;margin-top:0;">${planSuggestions}</div>` : ''}
// ${labRemark ? `<div style="white-space: pre-line;margin-top:0;">${labRemark}</div>` : ''}
// ${orderHtmlPlan ? ` <div>${orderHtmlPlan}</div>` : ''}                
// ${planFormat ? `<div>${planFormat}</div>` : ''}
// ${allTreamentStatements[diagnosis] ? `<div style="white-space: pre-line;margin-top:0;">${allTreamentStatements[diagnosis]}</div>` : ''}
// </div>  `
//               : ''
        } else {
        }
        //         const selfCareAssessmentFormat = formattedSelfCareAssessment || ''

// selfCareHtmlContent = selfCareAssessmentFormat
//   ? `
// <div>
//   <ul style="margin:4px 0 0 15px; padding-left:15px;">
//     ${toBulletItems(selfCareAssessmentFormat)}
//   </ul>
// </div>
// `
//   : ''
        // poa

        // let oldNotePoa = patientTreatments?.filter((item, index) => (noteID === 0 ? index === 0 : item?.data?.noteID < noteID)).map((item) => item?.data?.poa || {})
        // let submission = questionValue?.filter((item) => {
        //   const diagnosisExists = oldNotePoa?.some((poaItem) => Object.keys(poaItem).includes(item.diagnosis))
        //   return noteID === 0 ? diagnosisExists : !diagnosisExists
        // })
        // submission = submission.find((item) => item.diagnosis === diagnosis) || (patientTreatments?.length === 1 ? questionValue?.find((item) => item.diagnosis === diagnosis) || {} : {})
        // // const submission = questionValue.find((item) => item.diagnosis === diagnosis) || {};
        // const matchedQuestion = questions.find((item) => item.diagnosis === diagnosis)

        // const data = submission.data && submission.data[0] // First object

        // const formatted = Object.entries(data || {}).map(([key, value]) => {
        //   const question = key.replace(/([A-Z])/g, ' $1').replace(/^./, (str) => str.toUpperCase())

        //   const answer = Array.isArray(value) ? (value.length > 0 ? value.join(',') : '') : value || 'No'

        //   return { question, answer }
        // })
        // .filter(item => item.answer !== "");


        return `
<table style="width: 100%; font-size: 11pt; margin-top: 10pt; border-collapse: collapse; table-layout: fixed;">
<tr style="vertical-align: top;">
<td style="width: 30%; font-weight: bold; font-size: 13pt; padding: 6px 24px 6px 0; border: 0; line-height: normal; vertical-align: top;"><div style="margin:5pt 0;"><p style="margin:0;">${diagnosis?.toUpperCase()}</p></div></td>
<td style="width: 70%; padding: 6px 0 6px 12px; border: 0; line-height: normal; vertical-align: top;">
  


${
  incidentHtmlContent
    ? `
<div style="margin-bottom:5pt;margin-top:5pt">
<p style="margin:0;font-weight:700;line-height:22px;font-size:11pt;">Incident</p>
${incidentHtmlContent}
</div>`
    : ''
}

${riskFactorHtmlContent}

${ddxHtmlsTreatMents}

${alertHtml}

        

${assessmentHtmlContent}
 
${planHtmlContent}

</td>
</tr>
</table>
</>
<table style="width:100%; border-collapse:collapse; border:none; margin:6px 0;">
<tr style="border:none; height:0; line-height:0;">
<td style="padding:0; border:none; border-bottom:0.5px solid gray; height:0; line-height:0;"></td>
</tr>
</table>
</div>
</div>


</div>

`
      })
      .join('')

    // const [addendum, setAddendum] = useState([])
    //      const fetchAddendumData = async () => {
    //             try {
    //                 let data = await SaveExtra('Get_By_Type', 'Addendum', '', '');

    //                 data = JSON.parse(data?.d)?.Data || [];

    //                 data = data.map(item => JSON.parse(item?.JsonData));
    //                 data = data.reverse(); // latest first

    //                 const currentNoteID = noteID.toString();
    //                 const noteIDNum = parseInt(noteID, 10);
    //                 const previousNoteID = noteIDNum > 0 ? (noteIDNum - 1).toString() : null;

    //                 const findPatientNoteData = (data, patientID, noteID) => {
    //                     for (let i = 0; i < data.length; i++) {
    //                         const item = data[i];

    //                         if (item[patientID]) {

    //                             if (item[patientID][currentNoteID]) {
    //                                 return item[patientID][currentNoteID];
    //                             }

    //                             if (previousNoteID && item[patientID][previousNoteID]) {
    //                                 return item[patientID][previousNoteID];
    //                             }
    //                         }
    //                     }
    //                     return null;
    //                 };

    //                 const result = findPatientNoteData(data, patientID, noteID);
    //                 if (result) {
    //                     setAddendum(result);
    //                 } else {
    //                     const searchNotes = noteIDNum > 0 ? `${noteID} or ${noteIDNum - 1}` : noteID;
    //                     console.warn(`Patient ${patientID} with note ${searchNotes} not found`);
    //                     setAddendum(null);
    //                 }
    //             } catch (error) {
    //                 console.error('Failed to fetch addendum data:', error);
    //                 setAddendum(null);
    //             }
    //         };

    //         useEffect(() => {
    //             fetchAddendumData();
    //         }, []);

    // Function to format date from DD-MM-YYYY to MM/DD/YYYY
    const formatDateNew = (dateString) => {
      if (!dateString) return ''
      const parts = dateString.split('-')
      if (parts.length !== 3) return dateString
      const [month, day, year] = parts
      const date = new Date(`${year}-${month}-${day}`)
      return new Intl.DateTimeFormat('en-US', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      }).format(date)
    }

    // Function to generate HTML-formatted text for Syncfusion Rich Text Editor
    const generateAddendumHTMLText = (addendumData) => {
      if (!addendumData || !addendumData.orders || addendumData.orders.length === 0) {
        return null
      }
      const formattedDate = formatDateNew(addendumData?.syncDate)

      const labelCellStyle = 'width:30%; border:0; font-weight:bold; font-size:13pt; padding:16px 0; vertical-align:top;'
      const valueCellStyle = 'width:70%; border:0; font-size:11pt; padding:16px 0; vertical-align:top;'
      const formatList = (items) => items.filter(Boolean).join(', ')
      const ordersHtml = addendumData.orders
        .map((currentOrder, idx) => {
          const medications = currentOrder.medication?.medication?.map((medItem) => {
            const details = [medItem.name, medItem.dosage, medItem.route, medItem.frequency].filter(Boolean).join(' ')
            return medItem.reason ? `${details} - ${medItem.reason}` : details
          }) || []
          const labs = currentOrder.lab?.labs?.map((labItem) => {
            const lab = labItem.lab || ''
            return labItem.reason ? `${lab} - Reason for ${lab}: ${labItem.reason}` : lab
          }) || []
          const imaging = currentOrder.imaging?.imagingTypes?.map((img) => (typeof img?.type === 'object' ? JSON.stringify(img?.type) : img?.type || '')) || []
          const miscellaneous = currentOrder.miscellaneous?.miscellaneous?.map((miscItem) => (typeof miscItem === 'object' ? miscItem?.type || '' : miscItem)) || []

          return `
<div style="${idx === addendumData.orders.length - 1 ? '' : 'margin-bottom:8px; padding-bottom:8px; border-bottom:0.5px solid #d8dbe0;'}">
${currentOrder.diagnosis ? `<div><strong>Diagnosis:</strong> ${currentOrder.diagnosis}</div>` : ''}
${medications.length ? `<div><strong>Medications:</strong> ${formatList(medications)}</div>` : ''}
${labs.length ? `<div><strong>Labs:</strong> ${formatList(labs)}</div>` : ''}
${imaging.length ? `<div><strong>Imaging:</strong> ${formatList(imaging)}</div>` : ''}
${miscellaneous.length ? `<div><strong>Miscellaneous:</strong> ${formatList(miscellaneous)}</div>` : ''}
</div>`
        })
        .join('')
      const poacHtml = addendumData?.poac?.map((item) => item?.poacData?.content).filter(Boolean).join('<br/><br/>') || ''
      const addendumContent = `
<div><strong>Date:</strong> ${formattedDate}</div>
<div style="margin-top:10px;"><strong>Orders</strong></div>
<div style="margin-top:4px;">${ordersHtml}</div>
${poacHtml ? `
<div style="margin-top:16px;"><strong>POAC</strong></div>
<div style="margin-top:4px; white-space:pre-wrap;">${poacHtml}</div>
` : ''}
`

      return `
<table style="width:100%; font-size:11pt; border-collapse:collapse; margin-bottom:10px;">
<tr style="vertical-align:top; border-top:0.5px solid gray;">
<td style="${labelCellStyle}">ADDENDUM</td>
<td style="${valueCellStyle}">${addendumContent}</td>
</tr>
</table>`
    }
    const isSNFFacility = String(
      patientFacilityData?.Type ||
      patientData?.FacilityType ||
      patientData?.facilityType ||
      patientData?.Type ||
      patientData?.type ||
      '',
    ).trim().toLowerCase() === 'snf'
    const patientTypeHtml = isSNFFacility && patientData?.PatientType
      ? `<span style=margin:0;padding:0;line-height:normal;font-size:11pt;>Patient Type: <b>${patientData.PatientType}</b></span>`
      : ''

    const noteHTML = `
<div style="white-space: normal">

<table style="width: 100%; border: none; border-collapse: collapse;">
<tr style="border: none;">
<td style="border: none; font-weight: 700; font-size: 13pt;">
Cerebrum Healthcare LLC<br />
<span style="font-weight: 400;">
Correspondence address
</span><br />
<span style="font-weight: 400;">
3225 S MACDILL AVE STE 129-300, TAMPA, FL, 33629-8171
</span>
</td>
<td style="border: none; text-align: right; font-weight: 700; font-size: 13pt;">
Neurology Consult Note
</td>
</tr>
</table>
<table style="width:100%; border-collapse:collapse; border:none; margin:6px 0;">
<tr style="border:none; height:0; line-height:0;">
<td style="padding:0; border:none; border-bottom:0.5px solid gray; height:0; line-height:0;"></td>
</tr>
</table>

<br/>

<table style="width: 100%; border: none; border-collapse: collapse;">
<tr style="border: none;">
<td style="border: none; font-size: 13pt;">
<span style="border: none; font-weight: 700; font-size: 13pt;">${patientData?.FirstName || ''} ${patientData?.MiddleName || ''} ${patientData?.LastName || ''}</span></br>
 ${patientTypeHtml}

</td>
</tr>
</table>
<table style="width: 100%; border: none; border-collapse: collapse;">
<tr style="border: none;">
<td style="border: none;">
${patientData?.DOB ? `DOB: <b>${patientData.DOB}</b><br />` : ''}
${(() => {
  const signedNote = patientTreatments.find((note) => note?.status === 'Signed' && note?.data?.noteID === noteID)
  return signedNote
    ? `<br />Electronically signed by:
<b>${patientExtraData?.providerAssigned || patientData?.providerAssigned || ''}</b> ( ${signedNote?.data?.signatureInfo?.signedDate} , ${signedNote?.data?.signatureInfo?.signedTimeUs} )`
    : ''
})()}   <br />
Visit on ${patientExtraData?.scheduleStartTime ? patientExtraData?.scheduleStartTime?.split(' ')[0] || '' : patientData?.scheduleStartTime?.split(' ')[0] || ''}
</td>
</tr>
</table>
<table style="width:100%; border-collapse:collapse; border:none; margin:6px 0;">
<tr style="border:none; height:0; line-height:0;">
<td style="padding:0; border:none; border-bottom:0.5px solid gray; height:0; line-height:0;"></td>
</tr>
</table>

<br/>



<div>
<p style="margin:0;font-weight: 700;line-height:normal;font-size: 13pt;">Locations</p>
<div>
<span style=margin:0;padding:0;line-height:normal;font-size:11pt;>${patientFacilityData?.Name ? patientFacilityData?.Name : ''} ${patientFacilityData?.Type ? `(${patientFacilityData?.Type}) - ` : ''}   ${patientData?.Room ? patientData?.Room : ''}</span>
</div>
</div>

<br/>

${
  (lastHospitalRecord || '')?.trim()
    ? `<table style="width: 100%;border-collapse: collapse; font-size: 11pt; margin-bottom: 10px;">
<tr style="vertical-align: top;">
<td style="width: 30%; font-weight: bold; font-size: 13pt;border: 0; padding: 6px 0;">HOSPITAL RECORDS </td>
<td style="width: 70%; padding: 6px 0px;border: 0;">${lastHospitalRecord}</td>
</tr>
</table>


`
    : ''
}



${!showDataIfNoteIsFollowUp && formattedHistories ? `<div>${formattedHistories}</div> ` : ''}
<table style="width:100%; border-collapse:collapse; border:none; margin:6px 0;">
<tr style="border:none; height:0; line-height:0;">
<td style="padding:0; border:none; border-bottom:0.5px solid gray; height:0; line-height:0;"></td>
</tr>
</table>

<div>${formattedAllergies}</div>
<table style="width:100%; border-collapse:collapse; border:none; margin:6px 0;">
<tr style="border:none; height:0; line-height:0;">
<td style="padding:0; border:none; border-bottom:0.5px solid gray; height:0; line-height:0;"></td>
</tr>
</table>

${
  formattedVitals
    ? `<table style="width: 100%; font-size: 11pt; margin-bottom: 10px; border-collapse: collapse;border:0;">
<tr style="vertical-align: top;">
<td style="width: 30%; font-weight: bold; font-size: 13pt; padding-top: 10pt;padding: 0pt; line-height: normal;border:0;">Vitals</td>
<td style="width: 70%; padding: 6px 0px; line-height: normal;border:0;">
${formattedVitals || ''}
</td>
</tr>
</table>
<table style="width:100%; border-collapse:collapse; border:none; margin:6px 0;">
<tr style="border:none; height:0; line-height:0;">
<td style="padding:0; border:none; border-bottom:0.5px solid gray; height:0; line-height:0;"></td>
</tr>
</table>

`
    : ''
}


${
  medicationNotes
    ? `<table style="width: 100%; font-size: 11pt; margin-top: 10pt; border-collapse: collapse;">
<tr style="">
<td style="width: 30%; font-weight: bold; font-size: 13pt; padding: 6px 0; border: 0;">Managed  Medication (Full medication list reviewd in Faciltiy EMR)</td>
<td style="width: 70%; padding: 6px 0px; border: 0; line-height: normal;">
${medicationNotes || ''}
</td>
</tr>
</table>
<table style="width:100%; border-collapse:collapse; border:none; margin:6px 0;">
<tr style="border:none; height:0; line-height:0;">
<td style="padding:0; border:none; border-bottom:0.5px solid gray; height:0; line-height:0;"></td>
</tr>
</table>`
    : ''
}

${
  allLabsParentHtml
    ? `<table style="width: 100%; font-size: 11pt; margin-top: 10pt; border-collapse: collapse;">
<tr style="vertical-align: top;">
<td style="width: 30%; font-weight: bold; font-size: 13pt; padding: 6px 0; border: 0;">Labs</td>
<td style="width: 70%; padding: 6px 0px; border: 0; line-height: normal;">
${allLabsParentHtml || ''}
</td>
</tr>
</table>
<table style="width:100%; border-collapse:collapse; border:none; margin:6px 0;">
<tr style="border:none; height:0; line-height:0;">
<td style="padding:0; border:none; border-bottom:0.5px solid gray; height:0; line-height:0;"></td>
</tr>
</table>
`
    : ''
}


${
  imagingNote
    ? `<table style="width: 100%; font-size: 11pt; margin-top: 10pt; border-collapse: collapse;">
<tr style="vertical-align: top;">
<td style="width: 30%; font-weight: bold; font-size: 13pt; padding: 6px 0; border: 0;">Imaging</td>
<td style="width: 70%; padding: 6px 0px; border: 0; line-height: normal;">
${imagingNote || ''}
</td>
</tr>
</table>
<table style="width:100%; border-collapse:collapse; border:none; margin:6px 0;">
<tr style="border:none; height:0; line-height:0;">
<td style="padding:0; border:none; border-bottom:0.5px solid gray; height:0; line-height:0;"></td>
</tr>
</table>`
    : ''
}



${
  incidentRemarkGlobal || incidentHtmlParentContent
    ? `<table style="width: 100%; font-size: 11pt; margin-top: 10pt; border-collapse: collapse;">
<tr>
<td style="width: 30%; font-weight: bold; font-size: 13pt; padding: 6px 0; border: 0; vertical-align: top;">
<div>Incident</div>
</td>
<td style="width: 70%; padding: 6px 0px; border: 0; line-height: normal;">
${incidentRemarkGlobal ? `<div style="margin: 0 0 6pt 0; white-space: pre-wrap;">${incidentRemarkGlobal}</div>` : ''}
${incidentHtmlParentContent || ''}
</td>
</tr>
</table>
<table style="width:100%; border-collapse:collapse; border:none; margin:6px 0;">
<tr style="border:none; height:0; line-height:0;">
<td style="padding:0; border:none; border-bottom:0.5px solid gray; height:0; line-height:0;"></td>
</tr>
</table>`
    : ''
}
 
${
   newFreeTypeText || hpiNotes || subjective?.[noteID]?.medicationRemarksForSubjective || (subjective[noteID]?.data)
    ? `<table style="width: 100%; font-size: 11pt; margin-top: 10pt; border-collapse: collapse;">
<tr style="">
<td style="width: 30%; font-weight: bold; font-size: 13pt; padding: 6px 0; border: 0; vertical-align: top;"><div>${hpiHeading ? hpiHeading : patientData?.Status === 'Follow Up' ? 'Subjective' : 'HPI'}</div></td>
<td style="width: 70%; padding: 6px 0px; border: 0; line-height: normal;">
<div>
${newFreeTypeText ? `<div style="white-space: pre-line;margin-top:0;margin-bottom:2pt">${newFreeTypeText}</div>` : ''}
${subjective?.[noteID]?.medicationRemarksForSubjective && noteID > 0 ? `<div style="white-space: pre-line;margin-top:0;margin-bottom:2pt;">${subjective[noteID]?.medicationRemarksForSubjective}</div>` : ''}
${hpiNotes ? `<div>${hpiNotes}</div>` : ''}
${  subjective[noteID]?.data ? `<div style="white-space: pre-line;margin-top:0;margin-bottom:2pt">${subjective[noteID]?.data}</div>` : ''}
</div>
</tr>
</table>

<table style="width:100%; border-collapse:collapse; border:none; margin:6px 0;">
<tr style="border:none; height:0; line-height:0;">
<td style="padding:0; border:none; border-bottom:0.5px solid gray; height:0; line-height:0;"></td>
</tr>
</table>`
    : ''
}
${
  reviewSystemHtml
    ? `<table style="width: 100%; font-size: 11pt; margin-top: 10pt; border-collapse: collapse;">
<tr style="vertical-align: top;">
<td style="width: 30%; font-weight: bold; font-size: 13pt; padding: 6px 0; border: 0;">Review Of System</td>
<td style="width: 70%; padding: 6px 0px; border: 0; line-height: normal;">
${reviewSystemHtml || ''}
</td>
</tr>
</table>
<table style="width:100%; border-collapse:collapse; border:none; margin:6px 0;">
<tr style="border:none; height:0; line-height:0;">
<td style="padding:0; border:none; border-bottom:0.5px solid gray; height:0; line-height:0;"></td>
</tr>
</table>`
    : ''
}


${
  finalHtml || peGlobalRemark
    ? ` <table style="width: 100%; font-size: 11pt; margin-top: 10pt; border-collapse: collapse;">
<tr style="vertical-align: top;">
<td style="width: 30%; font-weight: bold; font-size: 13pt; padding: 6px 0; border: 0;">Physical Examination</td>
<td style="width: 70%; padding: 6px 0px; border: 0; line-height: normal;">
<p style="white-space: pre-wrap;">${peGlobalRemark}</p>
${finalHtml || ''}
</td>
</tr>
</table>
<table style="width:100%; border-collapse:collapse; border:none; margin:6px 0;">
<tr style="border:none; height:0; line-height:0;">
<td style="padding:0; border:none; border-bottom:0.5px solid gray; height:0; line-height:0;"></td>
</tr>
</table>`
    : ''
}




<br/>

${poaRowsHTML || freeTypeGlobal
    ? `<p style="margin:0;font-weight:700;line-height:normal;font-size:13pt;padding-bottom:10pt;">POA</p>
${freeTypeGlobal ? `<div style="margin:0;line-height:normal;padding-bottom:10pt;white-space:pre-wrap;">${freeTypeGlobal}</div>` : ''}
<table style="width:100%; border-collapse:collapse; border:none; margin:6px 0;">
<tr style="border:none; height:0; line-height:0;">
<td style="padding:0; border:none; border-bottom:0.5px solid gray; height:0; line-height:0;"></td>
</tr>
</table>
${poaRowsHTML}
<br/>`
    : ''
}

${historyRowsHTML
    ? `<p style="margin:0;font-weight:700;line-height:normal;font-size:13pt;padding-bottom:10pt;">History of Diagnosis</p>
<table style="width:100%; border-collapse:collapse; border:none; margin:6px 0;">
<tr style="border:none; height:0; line-height:0;">
<td style="padding:0; border:none; border-bottom:0.5px solid gray; height:0; line-height:0;"></td>
</tr>
</table>
${historyRowsHTML}
<br/>`
    : ''}

${treatmentShellHTML
        ? `<p style="margin:0;font-weight: 700;line-height:normal;font-size: 13pt;padding-bottom:10pt;">ASSESSMENT/PLAN</p>

<div style="padding: " >
<table style="width:100%; border-collapse:collapse; border:none; margin:6px 0;">
<tr style="border:none; height:0; line-height:0;">
<td style="padding:0; border:none; border-bottom:0.5px solid gray; height:0; line-height:0;"></td>
</tr>
</table>
${treatmentShellHTML}
</div>
<br/>`
    : ''
}

${
  generateAddendumHTMLText(addendumData)
    ? `
<div style="padding: 0;">
${generateAddendumHTMLText(addendumData)}
</div>
`
    : ''
}
<br/>

</div>


`.trim()

    if (isInitialNoteDataReady) {
      setIsNotePreviewLoading(true)
    }
    setTextareaInputValue(noteHTML)
  }, [
    isInitialNoteDataReady,
    patientFacilityData,
    patientExtraData,
    patientData,
    patientTreatments,
    hospitalRecords,
    patientDiagnosis,
    allHistoriesList,
    allergies,
    vitalsList,
    medication,
    allLabs,
    imaging,
    incidentRemarkGlobal,
    questionValue,
    finalHtml,
    peGlobalRemark,
    freeTypeGlobal,
    hpiAdded,
    patientFinalNoteHpi,
    newFreeTypeText,
    subjective,
    addendumData,
    showDataIfNoteIsFollowUp,
    hpiHeading,
    noteID,
    noteStructureRef,
  ])

  useEffect(() => {
    if (notePreviewReadyTimerRef.current) {
      clearTimeout(notePreviewReadyTimerRef.current)
    }

    if (!isInitialNoteDataReady || isAddendumLoading || !textareaInputValue?.trim()) {
      setIsNotePreviewLoading(true)
      return
    }

    setIsNotePreviewLoading(true)
    notePreviewReadyTimerRef.current = setTimeout(() => {
      setIsNotePreviewLoading(false)
    }, 350)

    return () => {
      if (notePreviewReadyTimerRef.current) {
        clearTimeout(notePreviewReadyTimerRef.current)
      }
    }
  }, [isInitialNoteDataReady, isAddendumLoading, textareaInputValue])

  const showNotePreviewLoader = loading || isNotePreviewLoading
  const renderNotePreviewLoader = () => <Loader height={noteShow ? '60vh' : '55vh'} />
  const handleToolbarPdfDownload = async (event) => {
    event.preventDefault()
    try {
      setIsPdfExporting(true)
      await new Promise((resolve) => setTimeout(resolve, 100))
      await toPDF({
        filename: patientNotePdfFileName,
        resolution: Resolution.MEDIUM,
        page: {
          margin: {
            top: 10,
            right: 14,
            bottom: 10,
            left: 14,
          },
        },
        canvas: {
          mimeType: 'image/jpeg',
          qualityRatio: 0.95,
        },
        overrides: {
          canvas: {
            backgroundColor: '#ffffff',
            scale: Resolution.MEDIUM,
          },
        },
      })
    } finally {
      setIsPdfExporting(false)
    }
  }

  return (
    <>
      <style>{patientNoteEditorStyles}</style>
      {noteShow && (
        <div className="w-100  text-center rounded-pill py-2 " style={{}} textBgColor="primary">
          Note
        </div>
      )}
      {/* 
{showTreatmentAsAccordion && <span className='d-flex align-items-end justify-content-end'>
<CButton variant='outline' style={{ width: "50px!important" }} className='' onClick={() => toPDF({ page: { margin: "Margin.SMALL" } })}>Download Pdf</CButton>
</span>} */}
      <div className="patient-note-pdf-export-shell" aria-hidden="true">
        <div ref={targetRef} className="patient-note-pdf-export-surface" dangerouslySetInnerHTML={{ __html: textareaInputValue || '' }} />
      </div>
      {console.log("patientDetails", patientData)}
      {showNotePreviewLoader ? (
        renderNotePreviewLoader()
      ) : (
        <div className="custom-scrollbar">
          <div className="control-pane">
            <div className="control-section" id="rte">
              <div className="rte-control-section " style={{ background: '#191919' }}>
                {/* Syncfusion editor kept commented for rollback if needed. */}
                {/* <RichTextEditorComponent ... /> */}
                <div className={`patient-note-html-editor ${role === 'provider' ? 'dark-rte' : ''}`}>
                  <Editor
                    value={textareaInputValue || ''}
                    onChange={(event) => setTextareaInputValue(event.target.value)}
                    containerProps={{
                      style: {
                        border: 'none',
                      },
                    }}
                    style={{
                      minHeight: noteShow ? '60vh' : '55vh',
                    }}
                  >
                    {showToolbar && onlyShowHTmlService ? (
                      <Toolbar>
                        <BtnUndo />
                        <BtnRedo />
                        <Separator />
                        <button className="rsw-btn" type="button" title="Download PDF" onMouseDown={handleToolbarPdfDownload}>
                          PDF
                        </button>
                        <Separator />
                        <BtnBold />
                        <BtnItalic />
                        <BtnUnderline />
                        <BtnStrikeThrough />
                        <Separator />
                        <BtnStyles />
                        <Separator />
                        <BtnNumberedList />
                        <BtnBulletList />
                        <Separator />
                        <BtnLink />
                      </Toolbar>
                    ) : (
                      <Toolbar hidden />
                    )}
                  </Editor>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <CModal visible={visible} onClose={() => setVisible(false)} backdrop="static" keyboard={false} portal={false}>
        <CModalHeader onClose={() => setVisible(false)}>
          <CModalTitle>New Diagnosis</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <div className="mb-3">
            <CFormLabel>Select Diagnosis</CFormLabel>

            <Select
              placeholder="Select"
              onChange={(e) => {
                diagnosisChanged(e)
              }}
              options={diagnosisData}
              className="basic-multi-select"
              classNamePrefix="select"
            />
          </div>
        </CModalBody>
        <CModalFooter>
          <CButton color="primary" onClick={handleModalSave}>
            Add
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default PatientNoteViewInModal

// <div style="margin:0;padding:0;margin-bottom:0pt">
// <p style="margin:0;padding:0;">Medications</p>
// <div style="margin:0;padding:0;">
//   ${currentOrder?.medication?.medication?.map((medItem) => {
//       const name = typeof medItem?.name === "object" ? JSON.stringify(medItem?.name) : medItem?.name || "";
//       const dosage = medItem?.dosage || "";
//       const route = medItem?.route || "";
//       const frequency = medItem?.frequency || "";
//       const reason = typeof medItem?.reason === "object" ? JSON.stringify(medItem?.reason) : medItem?.reason || "";
//       return `<p style="margin:0;padding:0;"">${name} ${dosage} ${route}${frequency ? ` ${frequency}` : ""}${reason ? ` - ${reason}` : ""}</p>`;
//   }).join("") || ""
//   }
// </div>
// </div>
